const org = [
  {
    admin: "Stockholms län",
    area: 83.82,
    areaLake: 4.84,
    areaLand: 75.01,
    areaSea: 0.0,
    boundsNeLat: 59.5576182,
    boundsNeLng: 18.0040651,
    boundsSwLat: 59.4582726,
    boundsSwLng: 17.8572368,
    centerLat: 59.51961,
    centerLng: 17.92834,
    code: 114,
    name: "Upplands V\u00e4sby",
    population: 43891.0,
    populationDensity: 585.14,
  },
  {
    admin: "Stockholms län",
    area: 368.45,
    areaLake: 10.71,
    areaLand: 357.74,
    areaSea: 0.0,
    boundsNeLat: 59.53162308,
    boundsNeLng: 17.96806018,
    boundsSwLat: 59.52892512,
    boundsSwLng: 17.96536222,
    centerLat: 59.5302741,
    centerLng: 17.9667112,
    code: 115,
    name: "Vallentuna",
    population: 32785.0,
    populationDensity: 91.64,
  },
  {
    admin: "Stockholms län",
    area: 554.65,
    areaLake: 10.9,
    areaLand: 312.37,
    areaSea: 231.18,
    boundsNeLat: 59.600716,
    boundsNeLng: 18.968054,
    boundsSwLat: 59.3849541,
    boundsSwLng: 18.1447791,
    centerLat: 59.5000584,
    centerLng: 18.3524853,
    code: 117,
    name: "\u00d6ster\u00e5ker",
    population: 43293.0,
    populationDensity: 138.6,
  },
  {
    admin: "Stockholms län",
    area: 2980.99,
    areaLake: 8.46,
    areaLand: 448.12,
    areaSea: 2523.54,
    boundsNeLat: 59.3640911,
    boundsNeLng: 18.462124,
    boundsSwLat: 59.2984415,
    boundsSwLng: 18.325353,
    centerLat: 59.333333,
    centerLng: 18.383333,
    code: 120,
    name: "V\u00e4rmd\u00f6",
    population: 42000.0,
    populationDensity: 93.72,
  },
  {
    admin: "Stockholms län",
    area: 63.03,
    areaLake: 1.11,
    areaLand: 53.79,
    areaSea: 0.0,
    boundsNeLat: 59.4157427,
    boundsNeLng: 17.8528114,
    boundsSwLat: 59.4043863,
    boundsSwLng: 17.8207966,
    centerLat: 59.410065,
    centerLng: 17.836804,
    code: 123,
    name: "J\u00e4rf\u00e4lla",
    population: 74412.0,
    populationDensity: 1383.38,
  },
  {
    admin: "Stockholms län",
    area: 384.53,
    areaLake: 1.16,
    areaLand: 217.46,
    areaSea: 0.0,
    boundsNeLat: 59.2955809,
    boundsNeLng: 17.8639943,
    boundsSwLat: 59.2625319,
    boundsSwLng: 17.7235888,
    centerLat: 59.2798338,
    centerLng: 17.7902246,
    code: 125,
    name: "Eker\u00f6",
    population: 27406.0,
    populationDensity: 126.03,
  },
  {
    admin: "Stockholms län",
    area: 140.67,
    areaLake: 8.66,
    areaLand: 131.03,
    areaSea: 0.0,
    boundsNeLat: 59.2866631,
    boundsNeLng: 18.1764119,
    boundsSwLat: 59.1392181,
    boundsSwLng: 17.866803,
    centerLat: 59.23633,
    centerLng: 17.9821561,
    code: 126,
    name: "Huddinge",
    population: 107538.0,
    populationDensity: 820.71,
  },
  {
    admin: "Stockholms län",
    area: 222.31,
    areaLake: 10.74,
    areaLand: 194.15,
    areaSea: 12.73,
    boundsNeLat: 59.2640638,
    boundsNeLng: 17.94174,
    boundsSwLat: 59.175961,
    boundsSwLng: 17.7542463,
    centerLat: 59.2459411,
    centerLng: 17.8408583,
    code: 127,
    name: "Botkyrka",
    population: 90675.0,
    populationDensity: 467.04,
  },
  {
    admin: "Stockholms län",
    area: 71.09,
    areaLake: 7.27,
    areaLand: 54.11,
    areaSea: 0.0,
    boundsNeLat: 59.223043,
    boundsNeLng: 17.7953711,
    boundsSwLat: 59.18936,
    boundsSwLng: 17.7080919,
    centerLat: 59.2,
    centerLng: 17.766667,
    code: 128,
    name: "Salem",
    population: 16615.0,
    populationDensity: 307.06,
  },
  {
    admin: "Stockholms län",
    area: 2161.18,
    areaLake: 6.52,
    areaLand: 457.85,
    areaSea: 1696.5,
    boundsNeLat: 59.1884394,
    boundsNeLng: 18.167098,
    boundsSwLat: 59.1770069,
    boundsSwLng: 18.1350832,
    centerLat: 59.1827236,
    centerLng: 18.1510906,
    code: 136,
    name: "Haninge",
    population: 85693.0,
    populationDensity: 187.16,
  },
  {
    admin: "Stockholms län",
    area: 100.52,
    areaLake: 3.39,
    areaLand: 69.23,
    areaSea: 27.91,
    boundsNeLat: 59.258714,
    boundsNeLng: 18.3157629,
    boundsSwLat: 59.2087207,
    boundsSwLng: 18.1754999,
    centerLat: 59.2425954,
    centerLng: 18.2833919,
    code: 138,
    name: "Tyres\u00f6",
    population: 47103.0,
    populationDensity: 680.38,
  },
  {
    admin: "Stockholms län",
    area: 325.23,
    areaLake: 6.82,
    areaLand: 235.29,
    areaSea: 0.0,
    boundsNeLat: 59.6494755,
    boundsNeLng: 17.8308551,
    boundsSwLat: 59.4314551,
    boundsSwLng: 17.4796776,
    centerLat: 59.5094727,
    centerLng: 17.6144117,
    code: 139,
    name: "Upplands-Bro",
    population: 26755.0,
    populationDensity: 113.71,
  },
  {
    admin: "Stockholms län",
    area: 176.99,
    areaLake: 16.27,
    areaLand: 152.74,
    areaSea: 0.0,
    boundsNeLat: 59.1957279,
    boundsNeLng: 17.4755061,
    boundsSwLat: 59.1510149,
    boundsSwLng: 17.3872201,
    centerLat: 59.178177,
    centerLng: 17.427816,
    code: 140,
    name: "Nykvarn",
    population: 10424.0,
    populationDensity: 68.25,
  },
  {
    admin: "Stockholms län",
    area: 71.22,
    areaLake: 5.34,
    areaLand: 60.69,
    areaSea: 5.19,
    boundsNeLat: 59.50914,
    boundsNeLng: 18.1494549,
    boundsSwLat: 59.417161,
    boundsSwLng: 17.9831791,
    centerLat: 59.4419,
    centerLng: 18.0703299,
    code: 160,
    name: "T\u00e4by",
    population: 69386.0,
    populationDensity: 1143.29,
  },
  {
    admin: "Stockholms län",
    area: 32.67,
    areaLake: 0.15,
    areaLand: 26.4,
    areaSea: 6.12,
    boundsNeLat: 59.429869,
    boundsNeLng: 18.0512542,
    boundsSwLat: 59.386519,
    boundsSwLng: 17.9916912,
    centerLat: 59.4079049,
    centerLng: 18.019075,
    code: 162,
    name: "Danderyd",
    population: 32653.0,
    populationDensity: 1236.86,
  },
  {
    admin: "Stockholms län",
    area: 57.96,
    areaLake: 3.21,
    areaLand: 52.62,
    areaSea: 2.14,
    boundsNeLat: 59.4984,
    boundsNeLng: 18.0163742,
    boundsSwLat: 59.3929649,
    boundsSwLng: 17.825145,
    centerLat: 59.43911,
    centerLng: 17.94148,
    code: 163,
    name: "Sollentuna",
    population: 71023.0,
    populationDensity: 1349.73,
  },
  {
    admin: "Stockholms län",
    area: 214.12,
    areaLake: 4.46,
    areaLand: 187.16,
    areaSea: 7.27,
    boundsNeLat: 59.4278409,
    boundsNeLng: 18.198229,
    boundsSwLat: 59.224443,
    boundsSwLng: 17.7768619,
    centerLat: 59.3293235,
    centerLng: 18.0685808,
    code: 180,
    name: "Stockholm",
    population: 935619.0,
    populationDensity: 4999.03,
  },
  {
    admin: "Stockholms län",
    area: 694.57,
    areaLake: 33.27,
    areaLand: 524.86,
    areaSea: 83.68,
    boundsNeLat: 59.2242369,
    boundsNeLng: 17.686328,
    boundsSwLat: 59.145044,
    boundsSwLng: 17.553966,
    centerLat: 59.195363,
    centerLng: 17.625689,
    code: 181,
    name: "S\u00f6dert\u00e4lje",
    population: 94631.0,
    populationDensity: 180.3,
  },
  {
    admin: "Stockholms län",
    area: 128.46,
    areaLake: 4.13,
    areaLand: 95.12,
    areaSea: 29.58,
    boundsNeLat: 59.324012,
    boundsNeLng: 18.1919651,
    boundsSwLat: 59.2896071,
    boundsSwLng: 18.1025549,
    centerLat: 59.307903,
    centerLng: 18.156042,
    code: 182,
    name: "Nacka",
    population: 99359.0,
    populationDensity: 1044.56,
  },
  {
    admin: "Stockholms län",
    area: 8.79,
    areaLake: 0.06,
    areaLand: 8.69,
    areaSea: 0.0,
    boundsNeLat: 59.3574018,
    boundsNeLng: 18.0094748,
    boundsSwLat: 59.3548677,
    boundsSwLng: 17.9973473,
    centerLat: 59.3555208,
    centerLng: 18.0034869,
    code: 183,
    name: "Sundbyberg",
    population: 47750.0,
    populationDensity: 5494.82,
  },
  {
    admin: "Stockholms län",
    area: 20.66,
    areaLake: 0.19,
    areaLand: 19.29,
    areaSea: 1.65,
    boundsNeLat: 59.399706,
    boundsNeLng: 18.0550844,
    boundsSwLat: 59.3392301,
    boundsSwLng: 17.9631101,
    centerLat: 59.3688791,
    centerLng: 18.0084334,
    code: 184,
    name: "Solna",
    population: 78129.0,
    populationDensity: 4050.23,
  },
  {
    admin: "Stockholms län",
    area: 51.11,
    areaLake: 0.38,
    areaLand: 30.8,
    areaSea: 19.87,
    boundsNeLat: 59.3915493,
    boundsNeLng: 18.2936239,
    boundsSwLat: 59.3349147,
    boundsSwLng: 18.0935972,
    centerLat: 59.36296,
    centerLng: 18.1468,
    code: 186,
    name: "Liding\u00f6",
    population: 46853.0,
    populationDensity: 1521.2,
  },
  {
    admin: "Stockholms län",
    area: 106.85,
    areaLake: 0.51,
    areaLand: 57.84,
    areaSea: 48.72,
    boundsNeLat: 59.4564151,
    boundsNeLng: 18.2222554,
    boundsSwLat: 59.4308553,
    boundsSwLng: 18.1404561,
    centerLat: 59.452788,
    centerLng: 18.183603,
    code: 187,
    name: "Vaxholm",
    population: 11621.0,
    populationDensity: 200.92,
  },
  {
    admin: "Stockholms län",
    area: 5869.88,
    areaLake: 98.63,
    areaLand: 2015.35,
    areaSea: 3755.27,
    boundsNeLat: 59.7786732,
    boundsNeLng: 18.7473535,
    boundsSwLat: 59.7391301,
    boundsSwLng: 18.6671649,
    centerLat: 59.7595841,
    centerLng: 18.7013584,
    code: 188,
    name: "Norrt\u00e4lje",
    population: 59420.0,
    populationDensity: 29.48,
  },
  {
    admin: "Stockholms län",
    area: 350.26,
    areaLake: 4.41,
    areaLand: 327.66,
    areaSea: 0.0,
    boundsNeLat: 59.631673,
    boundsNeLng: 17.7768909,
    boundsSwLat: 59.5950224,
    boundsSwLng: 17.6708235,
    centerLat: 59.6191463,
    centerLng: 17.7234191,
    code: 191,
    name: "Sigtuna",
    population: 46274.0,
    populationDensity: 141.23,
  },
  {
    admin: "Stockholms län",
    area: 1300.87,
    areaLake: 6.76,
    areaLand: 358.75,
    areaSea: 935.33,
    boundsNeLat: 58.94371,
    boundsNeLng: 17.9805926,
    boundsSwLat: 58.8811081,
    boundsSwLng: 17.9128592,
    centerLat: 58.902926,
    centerLng: 17.9465289,
    code: 192,
    name: "Nyn\u00e4shamn",
    population: 27752.0,
    populationDensity: 77.36,
  },
  {
    admin: "Uppsala län",
    area: 186.47,
    areaLake: 1.48,
    areaLand: 143.55,
    areaSea: 0.0,
    boundsNeLat: 59.904146,
    boundsNeLng: 17.7709899,
    boundsSwLat: 59.7624129,
    boundsSwLng: 17.5459043,
    centerLat: 59.8585638,
    centerLng: 17.6389267,
    code: 305,
    name: "H\u00e5bo",
    population: 20737.0,
    populationDensity: 144.46,
  },
  {
    admin: "Uppsala län",
    area: 614.85,
    areaLake: 20.29,
    areaLand: 215.24,
    areaSea: 378.6,
    boundsNeLat: 60.585658,
    boundsNeLng: 17.4660351,
    boundsSwLat: 60.557145,
    boundsSwLng: 17.4298978,
    centerLat: 60.5686067,
    centerLng: 17.4489129,
    code: 319,
    name: "\u00c4lvkarleby",
    population: 9445.0,
    populationDensity: 43.88,
  },
  {
    admin: "Uppsala län",
    area: 295.11,
    areaLake: 4.25,
    areaLand: 282.13,
    areaSea: 0.0,
    boundsNeLat: 59.7305958,
    boundsNeLng: 17.8166104,
    boundsSwLat: 59.7193452,
    boundsSwLng: 17.7845956,
    centerLat: 59.724971,
    centerLng: 17.800603,
    code: 330,
    name: "Knivsta",
    population: 17323.0,
    populationDensity: 61.4,
  },
  {
    admin: "Uppsala län",
    area: 1225.58,
    areaLake: 58.68,
    areaLand: 1166.9,
    areaSea: 0.0,
    boundsNeLat: 60.7313874,
    boundsNeLng: 18.7711579,
    boundsSwLat: 59.4050129,
    boundsSwLng: 16.678336,
    centerLat: 60.0092262,
    centerLng: 17.2714589,
    code: 331,
    name: "Heby",
    population: 13755.0,
    populationDensity: 11.79,
  },
  {
    admin: "Uppsala län",
    area: 2573.61,
    areaLake: 58.13,
    areaLand: 1546.33,
    areaSea: 969.34,
    boundsNeLat: 60.365315,
    boundsNeLng: 17.5421131,
    boundsSwLat: 60.3287969,
    boundsSwLng: 17.4962908,
    centerLat: 60.3458956,
    centerLng: 17.516906,
    code: 360,
    name: "Tierp",
    population: 20744.0,
    populationDensity: 13.41,
  },
  {
    admin: "Uppsala län",
    area: 2234.44,
    areaLake: 40.76,
    areaLand: 2182.41,
    areaSea: 0.0,
    boundsNeLat: 59.904146,
    boundsNeLng: 17.7709899,
    boundsSwLat: 59.7624129,
    boundsSwLng: 17.5459043,
    centerLat: 59.8585638,
    centerLng: 17.6389267,
    code: 380,
    name: "Uppsala",
    population: 214559.0,
    populationDensity: 98.31,
  },
  {
    admin: "Uppsala län",
    area: 1323.82,
    areaLake: 4.64,
    areaLand: 1178.35,
    areaSea: 0.0,
    boundsNeLat: 59.8551211,
    boundsNeLng: 17.59317,
    boundsSwLat: 59.8451654,
    boundsSwLng: 17.5511117,
    centerLat: 59.8496675,
    centerLng: 17.5726536,
    code: 381,
    name: "Enk\u00f6ping",
    population: 42988.0,
    populationDensity: 36.48,
  },
  {
    admin: "Uppsala län",
    area: 3486.25,
    areaLake: 28.06,
    areaLand: 1474.61,
    areaSea: 1984.22,
    boundsNeLat: 60.26175708,
    boundsNeLng: 18.37242068,
    boundsSwLat: 60.25905912,
    boundsSwLng: 18.36972272,
    centerLat: 60.2604081,
    centerLng: 18.3710717,
    code: 382,
    name: "\u00d6sthammar",
    population: 21822.0,
    populationDensity: 14.8,
  },
  {
    admin: "S\u00f6dermanlands län",
    area: 439.45,
    areaLake: 41.51,
    areaLand: 370.32,
    areaSea: 0.0,
    boundsNeLat: 59.0735809,
    boundsNeLng: 15.8961489,
    boundsSwLat: 59.0271121,
    boundsSwLng: 15.8532942,
    centerLat: 59.046478,
    centerLng: 15.876965,
    code: 428,
    name: "Ving\u00e5ker",
    population: 9099.0,
    populationDensity: 24.57,
  },
  {
    admin: "S\u00f6dermanlands län",
    area: 538.14,
    areaLake: 77.03,
    areaLand: 461.11,
    areaSea: 0.0,
    boundsNeLat: 59.04988038,
    boundsNeLng: 17.30765168,
    boundsSwLat: 59.04718242,
    boundsSwLng: 17.30495372,
    centerLat: 59.0485314,
    centerLng: 17.3063027,
    code: 461,
    name: "Gnesta",
    population: 10861.0,
    populationDensity: 23.55,
  },
  {
    admin: "S\u00f6dermanlands län",
    area: 2066.54,
    areaLake: 133.93,
    areaLand: 1420.46,
    areaSea: 512.02,
    boundsNeLat: 58.75404578,
    boundsNeLng: 17.00991578,
    boundsSwLat: 58.75134782,
    boundsSwLng: 17.00721782,
    centerLat: 58.7526968,
    centerLng: 17.0085668,
    code: 480,
    name: "Nyk\u00f6ping",
    population: 54924.0,
    populationDensity: 38.67,
  },
  {
    admin: "S\u00f6dermanlands län",
    area: 746.59,
    areaLake: 0.16,
    areaLand: 35.43,
    areaSea: 710.95,
    boundsNeLat: 58.67249598,
    boundsNeLng: 17.10835398,
    boundsSwLat: 58.66979802,
    boundsSwLng: 17.10565602,
    centerLat: 58.671147,
    centerLng: 17.107005,
    code: 481,
    name: "Oxel\u00f6sund",
    population: 11921.0,
    populationDensity: 336.47,
  },
  {
    admin: "S\u00f6dermanlands län",
    area: 826.04,
    areaLake: 107.55,
    areaLand: 718.49,
    areaSea: 0.0,
    boundsNeLat: 59.070989,
    boundsNeLng: 16.6174309,
    boundsSwLat: 59.0409961,
    boundsSwLng: 16.5666509,
    centerLat: 59.0579376,
    centerLng: 16.5879122,
    code: 482,
    name: "Flen",
    population: 16830.0,
    populationDensity: 23.42,
  },
  {
    admin: "S\u00f6dermanlands län",
    area: 1189.54,
    areaLake: 94.07,
    areaLand: 1020.16,
    areaSea: 0.0,
    boundsNeLat: 59.007928,
    boundsNeLng: 16.2507348,
    boundsSwLat: 58.9743879,
    boundsSwLng: 16.139623,
    centerLat: 58.9955511,
    centerLng: 16.2054756,
    code: 483,
    name: "Katrineholm",
    population: 33722.0,
    populationDensity: 33.06,
  },
  {
    admin: "S\u00f6dermanlands län",
    area: 1250.49,
    areaLake: 22.97,
    areaLand: 1099.89,
    areaSea: 0.0,
    boundsNeLat: 59.4087279,
    boundsNeLng: 16.5885638,
    boundsSwLat: 59.327076,
    boundsSwLng: 16.4245331,
    centerLat: 59.3712486,
    centerLng: 16.5098045,
    code: 484,
    name: "Eskilstuna",
    population: 103684.0,
    populationDensity: 94.27,
  },
  {
    admin: "S\u00f6dermanlands län",
    area: 975.09,
    areaLake: 15.27,
    areaLand: 739.42,
    areaSea: 0.0,
    boundsNeLat: 59.400146,
    boundsNeLng: 17.061378,
    boundsSwLat: 59.3436841,
    boundsSwLng: 16.9721279,
    centerLat: 59.3774523,
    centerLng: 17.0321193,
    code: 486,
    name: "Str\u00e4ngn\u00e4s",
    population: 34609.0,
    populationDensity: 46.81,
  },
  {
    admin: "S\u00f6dermanlands län",
    area: 664.67,
    areaLake: 7.62,
    areaLand: 209.79,
    areaSea: 447.35,
    boundsNeLat: 58.9144399,
    boundsNeLng: 17.5710619,
    boundsSwLat: 58.8903629,
    boundsSwLng: 17.5315089,
    centerLat: 58.8985136,
    centerLng: 17.5513527,
    code: 488,
    name: "Trosa",
    population: 12447.0,
    populationDensity: 59.33,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 668.99,
    areaLake: 16.31,
    areaLand: 433.97,
    areaSea: 0.0,
    boundsNeLat: 58.238214,
    boundsNeLng: 14.6778449,
    boundsSwLat: 58.220175,
    boundsSwLng: 14.6340051,
    centerLat: 58.2291051,
    centerLng: 14.6530212,
    code: 509,
    name: "\u00d6desh\u00f6g",
    population: 5335.0,
    populationDensity: 12.29,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 778.62,
    areaLake: 103.23,
    areaLand: 675.39,
    areaSea: 0.0,
    boundsNeLat: 58.0490711,
    boundsNeLng: 15.5690311,
    boundsSwLat: 57.702259,
    boundsSwLng: 14.9877159,
    centerLat: 57.8595195,
    centerLng: 15.2973458,
    code: 512,
    name: "Ydre",
    population: 3675.0,
    populationDensity: 5.44,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 1301.96,
    areaLake: 172.56,
    areaLand: 1129.4,
    areaSea: 0.0,
    boundsNeLat: 58.142883,
    boundsNeLng: 16.0911802,
    boundsSwLat: 57.8041161,
    boundsSwLng: 15.640129,
    centerLat: 57.9535789,
    centerLng: 15.8479635,
    code: 513,
    name: "Kinda",
    population: 9874.0,
    populationDensity: 8.74,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 603.87,
    areaLake: 78.13,
    areaLand: 525.74,
    areaSea: 0.0,
    boundsNeLat: 58.210788,
    boundsNeLng: 15.0682551,
    boundsSwLat: 58.1803831,
    boundsSwLng: 15.0229469,
    centerLat: 58.1966895,
    centerLng: 15.0474881,
    code: 560,
    name: "Boxholm",
    population: 5373.0,
    populationDensity: 10.22,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 780.28,
    areaLake: 93.68,
    areaLand: 686.6,
    areaSea: 0.0,
    boundsNeLat: 58.2139331,
    boundsNeLng: 16.0214571,
    boundsSwLat: 58.1830461,
    boundsSwLng: 15.967212,
    centerLat: 58.2021898,
    centerLng: 15.9972698,
    code: 561,
    name: "\u00c5tvidaberg",
    population: 11617.0,
    populationDensity: 16.92,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 1215.04,
    areaLake: 159.79,
    areaLand: 1055.25,
    areaSea: 0.0,
    boundsNeLat: 58.722167,
    boundsNeLng: 15.831963,
    boundsSwLat: 58.6872099,
    boundsSwLng: 15.7247072,
    centerLat: 58.7074884,
    centerLng: 15.773595,
    code: 562,
    name: "Finsp\u00e5ng",
    population: 21526.0,
    populationDensity: 20.4,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 2049.57,
    areaLake: 43.12,
    areaLand: 733.97,
    areaSea: 1272.46,
    boundsNeLat: 58.218258,
    boundsNeLng: 16.6163648,
    boundsSwLat: 58.1934421,
    boundsSwLng: 16.572921,
    centerLat: 58.2024514,
    centerLng: 16.6013626,
    code: 563,
    name: "Valdemarsvik",
    population: 7809.0,
    populationDensity: 10.64,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 1568.57,
    areaLake: 140.85,
    areaLand: 1427.72,
    areaSea: 0.0,
    boundsNeLat: 58.39551438,
    boundsNeLng: 15.56131278,
    boundsSwLat: 58.39281642,
    boundsSwLng: 15.55861482,
    centerLat: 58.3941654,
    centerLng: 15.5599638,
    code: 580,
    name: "Link\u00f6ping",
    population: 155817.0,
    populationDensity: 109.14,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 2048.39,
    areaLake: 108.99,
    areaLand: 1495.52,
    areaSea: 443.08,
    boundsNeLat: 58.706099,
    boundsNeLng: 15.8471323,
    boundsSwLat: 58.7021904,
    boundsSwLng: 15.7667674,
    centerLat: 58.7023914,
    centerLng: 15.8071836,
    code: 581,
    name: "Norrk\u00f6ping",
    population: 139363.0,
    populationDensity: 93.19,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 1330.55,
    areaLake: 19.38,
    areaLand: 674.27,
    areaSea: 631.54,
    boundsNeLat: 58.46574468,
    boundsNeLng: 16.35795648,
    boundsSwLat: 58.46304672,
    boundsSwLng: 16.35525852,
    centerLat: 58.4643957,
    centerLng: 16.3566075,
    code: 582,
    name: "S\u00f6derk\u00f6ping",
    population: 14402.0,
    populationDensity: 21.36,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 1266.75,
    areaLake: 68.54,
    areaLand: 982.99,
    areaSea: 0.0,
    boundsNeLat: 58.5427835,
    boundsNeLng: 15.01385,
    boundsSwLat: 58.5401715,
    boundsSwLng: 15.0073081,
    centerLat: 58.5414775,
    centerLng: 15.0105791,
    code: 583,
    name: "Motala",
    population: 43258.0,
    populationDensity: 44.01,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 413.26,
    areaLake: 16.46,
    areaLand: 191.6,
    areaSea: 0.0,
    boundsNeLat: 58.45348908,
    boundsNeLng: 14.90082318,
    boundsSwLat: 58.45079112,
    boundsSwLng: 14.89812522,
    centerLat: 58.4521401,
    centerLng: 14.8994742,
    code: 584,
    name: "Vadstena",
    population: 7348.0,
    populationDensity: 38.35,
  },
  {
    admin: "\u00d6sterg\u00f6tlands län",
    area: 557.38,
    areaLake: 10.38,
    areaLand: 547.0,
    areaSea: 0.0,
    boundsNeLat: 58.2782271,
    boundsNeLng: 14.6923084,
    boundsSwLat: 58.2311362,
    boundsSwLng: 14.6480021,
    centerLat: 58.2497209,
    centerLng: 14.6543704,
    code: 586,
    name: "Mj\u00f6lby",
    population: 26708.0,
    populationDensity: 48.83,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 553.89,
    areaLake: 36.21,
    areaLand: 517.68,
    areaSea: 0.0,
    boundsNeLat: 57.849852,
    boundsNeLng: 14.8278439,
    boundsSwLat: 57.8250111,
    boundsSwLng: 14.789236,
    centerLat: 57.838521,
    centerLng: 14.8178021,
    code: 604,
    name: "Aneby",
    population: 6603.0,
    populationDensity: 12.75,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 450.05,
    areaLake: 29.5,
    areaLand: 420.55,
    areaSea: 0.0,
    boundsNeLat: 57.3696891,
    boundsNeLng: 13.7677981,
    boundsSwLat: 57.339139,
    boundsSwLng: 13.7204112,
    centerLat: 57.3580398,
    centerLng: 13.7371898,
    code: 617,
    name: "Gnosj\u00f6",
    population: 9615.0,
    populationDensity: 22.86,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 211.04,
    areaLake: 10.91,
    areaLand: 200.13,
    areaSea: 0.0,
    boundsNeLat: 57.9303341,
    boundsNeLng: 13.9049962,
    boundsSwLat: 57.899339,
    boundsSwLng: 13.8537402,
    centerLat: 57.9165989,
    centerLng: 13.8773174,
    code: 642,
    name: "Mullsj\u00f6",
    population: 7226.0,
    populationDensity: 36.11,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 462.24,
    areaLake: 6.25,
    areaLand: 328.49,
    areaSea: 0.0,
    boundsNeLat: 57.92307,
    boundsNeLng: 14.105306,
    boundsSwLat: 57.8931019,
    boundsSwLng: 14.0560171,
    centerLat: 57.9093094,
    centerLng: 14.0743665,
    code: 643,
    name: "Habo",
    population: 11586.0,
    populationDensity: 35.27,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 1220.72,
    areaLake: 83.65,
    areaLand: 1137.07,
    areaSea: 0.0,
    boundsNeLat: 57.321566,
    boundsNeLng: 13.5836202,
    boundsSwLat: 57.280877,
    boundsSwLng: 13.5124279,
    centerLat: 57.2985,
    centerLng: 13.54326,
    code: 662,
    name: "Gislaved",
    population: 29478.0,
    populationDensity: 25.92,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 858.15,
    areaLake: 33.27,
    areaLand: 824.88,
    areaSea: 0.0,
    boundsNeLat: 57.5047019,
    boundsNeLng: 14.1627474,
    boundsSwLat: 57.4927111,
    boundsSwLng: 14.1307326,
    centerLat: 57.498707,
    centerLng: 14.14674,
    code: 665,
    name: "Vaggeryd",
    population: 13644.0,
    populationDensity: 16.54,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 1925.01,
    areaLake: 73.54,
    areaLand: 1480.21,
    areaSea: 0.0,
    boundsNeLat: 57.78514398,
    boundsNeLng: 14.16297798,
    boundsSwLat: 57.78244602,
    boundsSwLng: 14.16028002,
    centerLat: 57.783795,
    centerLng: 14.161629,
    code: 680,
    name: "J\u00f6nk\u00f6ping",
    population: 135297.0,
    populationDensity: 91.4,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 988.5,
    areaLake: 58.28,
    areaLand: 930.22,
    areaSea: 0.0,
    boundsNeLat: 57.65397338,
    boundsNeLng: 14.69968878,
    boundsSwLat: 57.65127542,
    boundsSwLng: 14.69699082,
    centerLat: 57.6526244,
    centerLng: 14.6983398,
    code: 682,
    name: "N\u00e4ssj\u00f6",
    population: 30820.0,
    populationDensity: 33.13,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 1382.43,
    areaLake: 166.61,
    areaLand: 1215.82,
    areaSea: 0.0,
    boundsNeLat: 57.218454,
    boundsNeLng: 14.0946799,
    boundsSwLat: 57.160463,
    boundsSwLng: 13.9924661,
    centerLat: 57.1831605,
    centerLng: 14.0478214,
    code: 683,
    name: "V\u00e4rnamo",
    population: 33906.0,
    populationDensity: 27.89,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 729.56,
    areaLake: 50.26,
    areaLand: 679.3,
    areaSea: 0.0,
    boundsNeLat: 57.4117899,
    boundsNeLng: 14.6843229,
    boundsSwLat: 57.3825861,
    boundsSwLng: 14.643416,
    centerLat: 57.3989958,
    centerLng: 14.6658136,
    code: 684,
    name: "S\u00e4vsj\u00f6",
    population: 11396.0,
    populationDensity: 16.78,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 1600.42,
    areaLake: 100.07,
    areaLand: 1500.35,
    areaSea: 0.0,
    boundsNeLat: 57.451331,
    boundsNeLng: 15.121841,
    boundsSwLat: 57.3921311,
    boundsSwLng: 15.04801,
    centerLat: 57.42746,
    centerLng: 15.08533,
    code: 685,
    name: "Vetlanda",
    population: 27241.0,
    populationDensity: 18.16,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 873.3,
    areaLake: 73.9,
    areaLand: 799.4,
    areaSea: 0.0,
    boundsNeLat: 57.777193,
    boundsNeLng: 15.3398519,
    boundsSwLat: 57.4969789,
    boundsSwLng: 14.7890102,
    centerLat: 57.5909402,
    centerLng: 15.0239091,
    code: 686,
    name: "Eksj\u00f6",
    population: 17129.0,
    populationDensity: 21.43,
  },
  {
    admin: "J\u00f6nk\u00f6pings län",
    area: 437.74,
    areaLake: 35.14,
    areaLand: 402.6,
    areaSea: 0.0,
    boundsNeLat: 58.057912,
    boundsNeLng: 15.01115,
    boundsSwLat: 58.005672,
    boundsSwLng: 14.9431549,
    centerLat: 58.035518,
    centerLng: 14.975696,
    code: 687,
    name: "Tran\u00e5s",
    population: 18794.0,
    populationDensity: 46.68,
  },
  {
    admin: "Kronobergs län",
    area: 1226.65,
    areaLake: 54.77,
    areaLand: 1171.88,
    areaSea: 0.0,
    boundsNeLat: 57.018246,
    boundsNeLng: 15.7965239,
    boundsSwLat: 56.8305691,
    boundsSwLng: 15.1323129,
    centerLat: 56.9373436,
    centerLng: 15.4446016,
    code: 760,
    name: "Uppvidinge",
    population: 9508.0,
    populationDensity: 8.11,
  },
  {
    admin: "Kronobergs län",
    area: 456.36,
    areaLake: 43.82,
    areaLand: 412.54,
    areaSea: 0.0,
    boundsNeLat: 56.8297769,
    boundsNeLng: 15.411291,
    boundsSwLat: 56.6857991,
    boundsSwLng: 15.225855,
    centerLat: 56.7573602,
    centerLng: 15.318206,
    code: 761,
    name: "Lessebo",
    population: 8760.0,
    populationDensity: 21.23,
  },
  {
    admin: "Kronobergs län",
    area: 1207.25,
    areaLake: 162.49,
    areaLand: 1044.76,
    areaSea: 0.0,
    boundsNeLat: 56.537858,
    boundsNeLng: 14.9983701,
    boundsSwLat: 56.516002,
    boundsSwLng: 14.940799,
    centerLat: 56.5247452,
    centerLng: 14.9785342,
    code: 763,
    name: "Tingsryd",
    population: 12393.0,
    populationDensity: 11.86,
  },
  {
    admin: "Kronobergs län",
    area: 1074.26,
    areaLake: 100.15,
    areaLand: 974.11,
    areaSea: 0.0,
    boundsNeLat: 56.915449,
    boundsNeLng: 14.5858261,
    boundsSwLat: 56.886719,
    boundsSwLng: 14.5146531,
    centerLat: 56.8992104,
    centerLng: 14.5560006,
    code: 764,
    name: "Alvesta",
    population: 19850.0,
    populationDensity: 20.38,
  },
  {
    admin: "Kronobergs län",
    area: 978.22,
    areaLake: 87.72,
    areaLand: 890.5,
    areaSea: 0.0,
    boundsNeLat: 56.5571197,
    boundsNeLng: 14.1550304,
    boundsSwLat: 56.5448193,
    boundsSwLng: 14.1230156,
    centerLat: 56.55097,
    centerLng: 14.139023,
    code: 765,
    name: "\u00c4lmhult",
    population: 16618.0,
    populationDensity: 18.66,
  },
  {
    admin: "Kronobergs län",
    area: 532.84,
    areaLake: 15.69,
    areaLand: 517.15,
    areaSea: 0.0,
    boundsNeLat: 57.238187,
    boundsNeLng: 15.844141,
    boundsSwLat: 56.3566439,
    boundsSwLng: 13.2767319,
    centerLat: 56.7183403,
    centerLng: 14.4114674,
    code: 767,
    name: "Markaryd",
    population: 9991.0,
    populationDensity: 19.32,
  },
  {
    admin: "Kronobergs län",
    area: 1914.25,
    areaLake: 248.8,
    areaLand: 1665.45,
    areaSea: 0.0,
    boundsNeLat: 56.8800485,
    boundsNeLng: 14.6209858,
    boundsSwLat: 56.8724508,
    boundsSwLng: 14.5994842,
    centerLat: 56.8750413,
    centerLng: 14.6091742,
    code: 780,
    name: "V\u00e4xj\u00f6",
    population: 89500.0,
    populationDensity: 53.74,
  },
  {
    admin: "Kronobergs län",
    area: 1995.13,
    areaLake: 247.25,
    areaLand: 1747.88,
    areaSea: 0.0,
    boundsNeLat: 56.856567,
    boundsNeLng: 13.9836381,
    boundsSwLat: 56.809782,
    boundsSwLng: 13.8987431,
    centerLat: 56.8338774,
    centerLng: 13.9410417,
    code: 781,
    name: "Ljungby",
    population: 28008.0,
    populationDensity: 16.02,
  },
  {
    admin: "Kalmar län",
    area: 799.42,
    areaLake: 48.32,
    areaLand: 751.1,
    areaSea: 0.0,
    boundsNeLat: 57.1711376,
    boundsNeLng: 16.0422364,
    boundsSwLat: 57.1590374,
    boundsSwLng: 16.0102216,
    centerLat: 57.165088,
    centerLng: 16.026229,
    code: 821,
    name: "H\u00f6gsby",
    population: 6080.0,
    populationDensity: 8.09,
  },
  {
    admin: "Kalmar län",
    area: 605.23,
    areaLake: 1.59,
    areaLand: 468.35,
    areaSea: 135.29,
    boundsNeLat: 56.41396868,
    boundsNeLng: 16.00011988,
    boundsSwLat: 56.41127072,
    boundsSwLng: 15.99742192,
    centerLat: 56.4126197,
    centerLng: 15.9987709,
    code: 834,
    name: "Tors\u00e5",
    population: 7063.0,
    populationDensity: 15.08,
  },
  {
    admin: "Kalmar län",
    area: 3043.54,
    areaLake: 1.2,
    areaLand: 667.25,
    areaSea: 2374.97,
    boundsNeLat: 56.530862,
    boundsNeLng: 16.4097581,
    boundsSwLat: 56.50701,
    boundsSwLng: 16.371316,
    centerLat: 56.5237566,
    centerLng: 16.3869163,
    code: 840,
    name: "M\u00f6rbyl\u00e5nga",
    population: 14916.0,
    populationDensity: 22.35,
  },
  {
    admin: "Kalmar län",
    area: 1187.0,
    areaLake: 65.5,
    areaLand: 1121.5,
    areaSea: 0.0,
    boundsNeLat: 57.512664,
    boundsNeLng: 15.867641,
    boundsSwLat: 57.4769979,
    boundsSwLng: 15.8108539,
    centerLat: 57.49484,
    centerLng: 15.8416513,
    code: 860,
    name: "Hultsfred",
    population: 14607.0,
    populationDensity: 13.02,
  },
  {
    admin: "Kalmar län",
    area: 941.04,
    areaLake: 8.62,
    areaLand: 599.41,
    areaSea: 333.02,
    boundsNeLat: 57.059597,
    boundsNeLng: 16.4655251,
    boundsSwLat: 57.0225089,
    boundsSwLng: 16.4153959,
    centerLat: 57.0415797,
    centerLng: 16.44312,
    code: 861,
    name: "M\u00f6nster\u00e5",
    population: 13395.0,
    populationDensity: 22.35,
  },
  {
    admin: "Kalmar län",
    area: 718.53,
    areaLake: 28.99,
    areaLand: 689.54,
    areaSea: 0.0,
    boundsNeLat: 56.6358669,
    boundsNeLng: 15.5572664,
    boundsSwLat: 56.6235921,
    boundsSwLng: 15.5252516,
    centerLat: 56.62973,
    centerLng: 15.541259,
    code: 862,
    name: "Emmaboda",
    population: 9348.0,
    populationDensity: 13.56,
  },
  {
    admin: "Kalmar län",
    area: 1250.87,
    areaLake: 3.96,
    areaLand: 956.62,
    areaSea: 290.38,
    boundsNeLat: 56.7283809,
    boundsNeLng: 16.3854989,
    boundsSwLat: 56.6465394,
    boundsSwLng: 16.2684111,
    centerLat: 56.6634447,
    centerLng: 16.356779,
    code: 880,
    name: "Kalmar",
    population: 66571.0,
    populationDensity: 69.59,
  },
  {
    admin: "Kalmar län",
    area: 1201.63,
    areaLake: 29.91,
    areaLand: 1171.72,
    areaSea: 0.0,
    boundsNeLat: 56.7511302,
    boundsNeLng: 15.9238814,
    boundsSwLat: 56.7388928,
    boundsSwLng: 15.8918666,
    centerLat: 56.745012,
    centerLng: 15.907874,
    code: 881,
    name: "Nybro",
    population: 20311.0,
    populationDensity: 17.33,
  },
  {
    admin: "Kalmar län",
    area: 2279.96,
    areaLake: 48.31,
    areaLand: 1046.66,
    areaSea: 1182.43,
    boundsNeLat: 57.2920961,
    boundsNeLng: 16.4884022,
    boundsSwLat: 57.239841,
    boundsSwLng: 16.3755291,
    centerLat: 57.2656993,
    centerLng: 16.4473984,
    code: 882,
    name: "Oskarshamn",
    population: 27006.0,
    populationDensity: 25.8,
  },
  {
    admin: "Kalmar län",
    area: 3594.61,
    areaLake: 152.45,
    areaLand: 1874.47,
    areaSea: 1569.86,
    boundsNeLat: 57.75961398,
    boundsNeLng: 16.63149098,
    boundsSwLat: 57.75691602,
    boundsSwLng: 16.62879302,
    centerLat: 57.758265,
    centerLng: 16.630142,
    code: 883,
    name: "V\u00e4stervik",
    population: 36438.0,
    populationDensity: 19.44,
  },
  {
    admin: "Kalmar län",
    area: 1219.8,
    areaLake: 79.58,
    areaLand: 1140.22,
    areaSea: 0.0,
    boundsNeLat: 57.6840129,
    boundsNeLng: 15.890071,
    boundsSwLat: 57.652537,
    boundsSwLng: 15.816974,
    centerLat: 57.6690339,
    centerLng: 15.858857,
    code: 884,
    name: "Vimmerby",
    population: 15636.0,
    populationDensity: 13.71,
  },
  {
    admin: "Kalmar län",
    area: 3654.12,
    areaLake: 3.56,
    areaLand: 677.84,
    areaSea: 2973.44,
    boundsNeLat: 56.8868909,
    boundsNeLng: 16.6841911,
    boundsSwLat: 56.866457,
    boundsSwLng: 16.6436681,
    centerLat: 56.8802297,
    centerLng: 16.6562355,
    code: 885,
    name: "Borgholm",
    population: 10930.0,
    populationDensity: 16.12,
  },
  {
    admin: "Gotlands län",
    area: 15242.28,
    areaLake: 31.77,
    areaLand: 3134.98,
    areaSea: 12074.32,
    boundsNeLat: 57.9298153,
    boundsNeLng: 19.1228588,
    boundsSwLat: 56.9049485,
    boundsSwLng: 18.0855621,
    centerLat: 57.4684121,
    centerLng: 18.4867447,
    code: 980,
    name: "Gotland",
    population: 58003.0,
    populationDensity: 18.5,
  },
  {
    admin: "Blekinge län",
    area: 413.44,
    areaLake: 23.65,
    areaLand: 389.79,
    areaSea: 0.0,
    boundsNeLat: 56.27941638,
    boundsNeLng: 14.52392188,
    boundsSwLat: 56.27671842,
    boundsSwLng: 14.52122392,
    centerLat: 56.2780674,
    centerLng: 14.5225729,
    code: 1060,
    name: "Olofstr\u00f6m",
    population: 13417.0,
    populationDensity: 34.42,
  },
  {
    admin: "Blekinge län",
    area: 3338.03,
    areaLake: 27.6,
    areaLand: 1042.05,
    areaSea: 2268.4,
    boundsNeLat: 56.230162,
    boundsNeLng: 15.6912351,
    boundsSwLat: 56.14811,
    boundsSwLng: 15.5606735,
    centerLat: 56.161224,
    centerLng: 15.5869,
    code: 1080,
    name: "Karlskrona",
    population: 66262.0,
    populationDensity: 63.59,
  },
  {
    admin: "Blekinge län",
    area: 1241.84,
    areaLake: 36.54,
    areaLand: 825.29,
    areaSea: 380.01,
    boundsNeLat: 56.2136676,
    boundsNeLng: 15.6124644,
    boundsSwLat: 56.1957947,
    boundsSwLng: 15.5874106,
    centerLat: 56.2054368,
    centerLng: 15.6037495,
    code: 1081,
    name: "Ronneby",
    population: 29207.0,
    populationDensity: 35.39,
  },
  {
    admin: "Blekinge län",
    area: 832.43,
    areaLake: 19.92,
    areaLand: 488.68,
    areaSea: 323.83,
    boundsNeLat: 56.16541688,
    boundsNeLng: 14.89637538,
    boundsSwLat: 56.16271892,
    boundsSwLng: 14.89367742,
    centerLat: 56.1640679,
    centerLng: 14.8950264,
    code: 1082,
    name: "Karlshamn",
    population: 32130.0,
    populationDensity: 65.75,
  },
  {
    admin: "Blekinge län",
    area: 1106.41,
    areaLake: 0.58,
    areaLand: 185.31,
    areaSea: 920.52,
    boundsNeLat: 56.5022141,
    boundsNeLng: 16.0679243,
    boundsSwLat: 55.9901428,
    boundsSwLng: 14.3528851,
    centerLat: 56.2783837,
    centerLng: 15.0180058,
    code: 1083,
    name: "S\u00f6lvesborg",
    population: 17437.0,
    populationDensity: 94.1,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 388.62,
    areaLake: 1.44,
    areaLand: 387.18,
    areaSea: 0.0,
    boundsNeLat: 55.92184,
    boundsNeLng: 13.118234,
    boundsSwLat: 55.9037431,
    boundsSwLng: 13.088994,
    centerLat: 55.9129296,
    centerLng: 13.1018168,
    code: 1214,
    name: "Sval\u00f6v",
    population: 13919.0,
    populationDensity: 35.95,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 107.27,
    areaLake: 0.49,
    areaLand: 106.78,
    areaSea: 0.0,
    boundsNeLat: 55.6582801,
    boundsNeLng: 13.355178,
    boundsSwLat: 55.595168,
    boundsSwLng: 13.1247249,
    centerLat: 55.641065,
    centerLng: 13.212229,
    code: 1230,
    name: "Staffanstorp",
    population: 23600.0,
    populationDensity: 221.02,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 19.21,
    areaLake: 0.13,
    areaLand: 18.9,
    areaSea: 0.18,
    boundsNeLat: 55.666606,
    boundsNeLng: 13.1406339,
    boundsSwLat: 55.602549,
    boundsSwLng: 13.0488918,
    centerLat: 55.6319129,
    centerLng: 13.096379,
    code: 1231,
    name: "Burl\u00f6v",
    population: 17646.0,
    populationDensity: 933.65,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 705.62,
    areaLake: 1.19,
    areaLand: 142.66,
    areaSea: 561.61,
    boundsNeLat: 55.488096,
    boundsNeLng: 13.043046,
    boundsSwLat: 55.456573,
    boundsSwLng: 13.0076679,
    centerLat: 55.4708928,
    centerLng: 13.0199899,
    code: 1233,
    name: "Vellinge",
    population: 35257.0,
    populationDensity: 247.14,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 451.14,
    areaLake: 19.3,
    areaLand: 431.84,
    areaSea: 0.0,
    boundsNeLat: 56.452628,
    boundsNeLng: 14.378548,
    boundsSwLat: 56.116664,
    boundsSwLng: 13.9645249,
    centerLat: 56.2378773,
    centerLng: 14.2161662,
    code: 1256,
    name: "\u00d6stra G\u00f6inge",
    population: 14406.0,
    populationDensity: 33.36,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 329.7,
    areaLake: 10.2,
    areaLand: 319.5,
    areaSea: 0.0,
    boundsNeLat: 56.301961,
    boundsNeLng: 13.311899,
    boundsSwLat: 56.266761,
    boundsSwLng: 13.2474369,
    centerLat: 56.283635,
    centerLng: 13.278832,
    code: 1257,
    name: "\u00d6rkelljunga",
    population: 9958.0,
    populationDensity: 31.17,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 115.8,
    areaLake: 0.49,
    areaLand: 115.31,
    areaSea: 0.0,
    boundsNeLat: 56.08614918,
    boundsNeLng: 12.91614258,
    boundsSwLat: 56.08345122,
    boundsSwLng: 12.91344462,
    centerLat: 56.0848002,
    centerLng: 12.9147936,
    code: 1260,
    name: "Bjuv",
    population: 15202.0,
    populationDensity: 131.84,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 292.44,
    areaLake: 1.09,
    areaLand: 152.54,
    areaSea: 138.82,
    boundsNeLat: 55.808029,
    boundsNeLng: 13.1518599,
    boundsSwLat: 55.7786061,
    boundsSwLng: 13.079571,
    centerLat: 55.7939999,
    centerLng: 13.1104293,
    code: 1261,
    name: "K\u00e4vlinge",
    population: 30532.0,
    populationDensity: 200.16,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 90.2,
    areaLake: 0.83,
    areaLand: 55.51,
    areaSea: 33.85,
    boundsNeLat: 55.68995,
    boundsNeLng: 13.0975299,
    boundsSwLat: 55.6587511,
    boundsSwLng: 13.0547431,
    centerLat: 55.6706674,
    centerLng: 13.077576,
    code: 1262,
    name: "Lomma",
    population: 23887.0,
    populationDensity: 430.32,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 227.11,
    areaLake: 9.2,
    areaLand: 217.91,
    areaSea: 0.0,
    boundsNeLat: 55.527168,
    boundsNeLng: 13.4725908,
    boundsSwLat: 55.421128,
    boundsSwLng: 13.1783852,
    centerLat: 55.5089084,
    centerLng: 13.2371097,
    code: 1263,
    name: "Svedala",
    population: 20771.0,
    populationDensity: 95.32,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 510.95,
    areaLake: 1.65,
    areaLand: 193.51,
    areaSea: 315.8,
    boundsNeLat: 55.48054788,
    boundsNeLng: 13.50235818,
    boundsSwLat: 55.47784992,
    boundsSwLng: 13.49966022,
    centerLat: 55.4791989,
    centerLng: 13.5010092,
    code: 1264,
    name: "Skurup",
    population: 15408.0,
    populationDensity: 79.62,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 506.64,
    areaLake: 14.63,
    areaLand: 492.01,
    areaSea: 0.0,
    boundsNeLat: 55.640587,
    boundsNeLng: 13.859235,
    boundsSwLat: 55.5098351,
    boundsSwLng: 13.5171429,
    centerLat: 55.5934072,
    centerLng: 13.6977756,
    code: 1265,
    name: "Sj\u00f6bo",
    population: 18742.0,
    populationDensity: 38.09,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 433.07,
    areaLake: 13.7,
    areaLand: 419.37,
    areaSea: 0.0,
    boundsNeLat: 55.8636679,
    boundsNeLng: 13.6816939,
    boundsSwLat: 55.8396759,
    boundsSwLng: 13.643817,
    centerLat: 55.851716,
    centerLng: 13.6619255,
    code: 1266,
    name: "H\u00f6rby",
    population: 15283.0,
    populationDensity: 36.44,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 319.87,
    areaLake: 29.32,
    areaLand: 290.55,
    areaSea: 0.0,
    boundsNeLat: 55.93341018,
    boundsNeLng: 13.54338318,
    boundsSwLat: 55.93071222,
    boundsSwLng: 13.54068522,
    centerLat: 55.9320612,
    centerLng: 13.5420342,
    code: 1267,
    name: "H\u00f6\u00f6r",
    population: 16192.0,
    populationDensity: 55.73,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 397.39,
    areaLake: 1.46,
    areaLand: 395.93,
    areaSea: 0.0,
    boundsNeLat: 55.570886,
    boundsNeLng: 13.9792422,
    boundsSwLat: 55.5302811,
    boundsSwLng: 13.9077371,
    centerLat: 55.54355,
    centerLng: 13.95484,
    code: 1270,
    name: "Tomelilla",
    population: 13330.0,
    populationDensity: 33.67,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 197.14,
    areaLake: 22.78,
    areaLand: 162.49,
    areaSea: 11.87,
    boundsNeLat: 56.07593078,
    boundsNeLng: 14.47137238,
    boundsSwLat: 56.07323282,
    boundsSwLng: 14.46867442,
    centerLat: 56.0745818,
    centerLng: 14.4700234,
    code: 1272,
    name: "Brom\u00f6lla",
    population: 12625.0,
    populationDensity: 77.7,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 599.85,
    areaLake: 23.47,
    areaLand: 576.38,
    areaSea: 0.0,
    boundsNeLat: 56.400339,
    boundsNeLng: 14.036506,
    boundsSwLat: 56.353252,
    boundsSwLng: 13.9648611,
    centerLat: 56.3815355,
    centerLng: 13.9929413,
    code: 1273,
    name: "Osby",
    population: 13149.0,
    populationDensity: 22.81,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 161.93,
    areaLake: 3.16,
    areaLand: 158.77,
    areaSea: 0.0,
    boundsNeLat: 55.4746061,
    boundsNeLng: 13.0257506,
    boundsSwLat: 55.4699345,
    boundsSwLng: 13.0169436,
    centerLat: 55.4726302,
    centerLng: 13.0232164,
    code: 1275,
    name: "Perstorp",
    population: 7338.0,
    populationDensity: 46.22,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 379.41,
    areaLake: 5.09,
    areaLand: 374.32,
    areaSea: 0.0,
    boundsNeLat: 56.13690128,
    boundsNeLng: 13.12930778,
    boundsSwLat: 56.13420332,
    boundsSwLng: 13.12660982,
    centerLat: 56.1355523,
    centerLng: 13.1279588,
    code: 1276,
    name: "Klippan",
    population: 17219.0,
    populationDensity: 46.0,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 92.62,
    areaLake: 0.27,
    areaLand: 92.35,
    areaSea: 0.0,
    boundsNeLat: 56.1481789,
    boundsNeLng: 12.9761791,
    boundsSwLat: 56.121007,
    boundsSwLng: 12.8903391,
    centerLat: 56.134262,
    centerLng: 12.945908,
    code: 1277,
    name: "\u00c5storp",
    population: 15528.0,
    populationDensity: 168.14,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 889.25,
    areaLake: 0.62,
    areaLand: 217.13,
    areaSea: 664.15,
    boundsNeLat: 56.42776678,
    boundsNeLng: 12.84751458,
    boundsSwLat: 56.42506882,
    boundsSwLng: 12.84481662,
    centerLat: 56.4264178,
    centerLng: 12.8461656,
    code: 1278,
    name: "B\u00e5stad",
    population: 14614.0,
    populationDensity: 67.31,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 332.61,
    areaLake: 1.76,
    areaLand: 156.6,
    areaSea: 173.93,
    boundsNeLat: 55.639951,
    boundsNeLng: 13.1507608,
    boundsSwLat: 55.5017314,
    boundsSwLng: 12.8894594,
    centerLat: 55.604981,
    centerLng: 13.003822,
    code: 1280,
    name: "Malm\u00f6",
    population: 328494.0,
    populationDensity: 2097.66,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 439.91,
    areaLake: 12.84,
    areaLand: 427.07,
    areaSea: 0.0,
    boundsNeLat: 55.7440789,
    boundsNeLng: 13.260202,
    boundsSwLat: 55.6695239,
    boundsSwLng: 13.13579,
    centerLat: 55.7046601,
    centerLng: 13.1910073,
    code: 1281,
    name: "Lund",
    population: 118542.0,
    populationDensity: 277.57,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 300.67,
    areaLake: 0.76,
    areaLand: 140.26,
    areaSea: 159.63,
    boundsNeLat: 55.9056341,
    boundsNeLng: 12.8832798,
    boundsSwLat: 55.8533971,
    boundsSwLng: 12.810608,
    centerLat: 55.8703477,
    centerLng: 12.8300802,
    code: 1282,
    name: "Landskrona",
    population: 44611.0,
    populationDensity: 318.06,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 423.93,
    areaLake: 1.43,
    areaLand: 343.89,
    areaSea: 78.6,
    boundsNeLat: 56.2350684,
    boundsNeLng: 12.8629462,
    boundsSwLat: 56.1836382,
    boundsSwLng: 12.8427726,
    centerLat: 56.2090107,
    centerLng: 12.8557318,
    code: 1283,
    name: "Helsingborg",
    population: 140547.0,
    populationDensity: 408.7,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 668.78,
    areaLake: 0.38,
    areaLand: 143.5,
    areaSea: 532.25,
    boundsNeLat: 56.219599,
    boundsNeLng: 12.5996919,
    boundsSwLat: 56.179702,
    boundsSwLng: 12.532773,
    centerLat: 56.2006388,
    centerLng: 12.5553288,
    code: 1284,
    name: "H\u00f6gan\u00e4s",
    population: 25847.0,
    populationDensity: 180.12,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 424.68,
    areaLake: 5.66,
    areaLand: 419.02,
    areaSea: 0.0,
    boundsNeLat: 55.85642,
    boundsNeLng: 13.3347121,
    boundsSwLat: 55.820682,
    boundsSwLng: 13.2682741,
    centerLat: 55.8391198,
    centerLng: 13.3033914,
    code: 1285,
    name: "Esl\u00f6v",
    population: 32878.0,
    populationDensity: 78.46,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 1189.26,
    areaLake: 5.04,
    areaLand: 350.0,
    areaSea: 834.28,
    boundsNeLat: 55.5459148,
    boundsNeLng: 13.2018407,
    boundsSwLat: 55.5283847,
    boundsSwLng: 13.1443448,
    centerLat: 55.5367258,
    centerLng: 13.1726454,
    code: 1286,
    name: "Ystad",
    population: 29448.0,
    populationDensity: 84.14,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 1175.07,
    areaLake: 2.38,
    areaLand: 339.8,
    areaSea: 832.83,
    boundsNeLat: 55.37485678,
    boundsNeLng: 13.15932448,
    boundsSwLat: 55.37215882,
    boundsSwLng: 13.15662652,
    centerLat: 55.3735078,
    centerLng: 13.1579755,
    code: 1287,
    name: "Trelleborg",
    population: 43913.0,
    populationDensity: 129.23,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 1817.25,
    areaLake: 94.13,
    areaLand: 1245.22,
    areaSea: 478.9,
    boundsNeLat: 55.565076,
    boundsNeLng: 14.3470449,
    boundsSwLat: 55.5562294,
    boundsSwLng: 14.33599,
    centerLat: 55.5606075,
    centerLng: 14.3412722,
    code: 1290,
    name: "Kristianstad",
    population: 83191.0,
    populationDensity: 66.81,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 1262.16,
    areaLake: 1.1,
    areaLand: 392.34,
    areaSea: 867.72,
    boundsNeLat: 55.5767769,
    boundsNeLng: 14.360677,
    boundsSwLat: 55.538923,
    boundsSwLng: 14.3260224,
    centerLat: 55.5573959,
    centerLng: 14.3489651,
    code: 1291,
    name: "Simrishamn",
    population: 19485.0,
    populationDensity: 49.66,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 477.93,
    areaLake: 11.29,
    areaLand: 419.87,
    areaSea: 46.75,
    boundsNeLat: 56.284446,
    boundsNeLng: 12.907386,
    boundsSwLat: 56.220303,
    boundsSwLng: 12.826298,
    centerLat: 56.245748,
    centerLng: 12.863881,
    code: 1292,
    name: "\u00c4ngelholm",
    population: 41336.0,
    populationDensity: 98.45,
  },
  {
    admin: "Sk\u00e5ne län",
    area: 1306.39,
    areaLake: 37.42,
    areaLand: 1268.97,
    areaSea: 0.0,
    boundsNeLat: 56.186562,
    boundsNeLng: 13.8253232,
    boundsSwLat: 56.1373,
    boundsSwLng: 13.7272251,
    centerLat: 56.1589145,
    centerLng: 13.7667655,
    code: 1293,
    name: "H\u00e4ssleholm",
    population: 51667.0,
    populationDensity: 40.72,
  },
  {
    admin: "Hallands län",
    area: 1046.6,
    areaLake: 100.07,
    areaLand: 946.53,
    areaSea: 0.0,
    boundsNeLat: 57.113513,
    boundsNeLng: 13.6937639,
    boundsSwLat: 56.823528,
    boundsSwLng: 13.2398811,
    centerLat: 56.9546839,
    centerLng: 13.5284689,
    code: 1315,
    name: "Hylte",
    population: 10954.0,
    populationDensity: 11.57,
  },
  {
    admin: "Hallands län",
    area: 1699.98,
    areaLake: 16.98,
    areaLand: 1013.97,
    areaSea: 668.94,
    boundsNeLat: 56.68109068,
    boundsNeLng: 12.88518248,
    boundsSwLat: 56.67839272,
    boundsSwLng: 12.88248452,
    centerLat: 56.6797417,
    centerLng: 12.8838335,
    code: 1380,
    name: "Halmstad",
    population: 98538.0,
    populationDensity: 97.18,
  },
  {
    admin: "Hallands län",
    area: 963.4,
    areaLake: 19.34,
    areaLand: 882.8,
    areaSea: 61.25,
    boundsNeLat: 56.5194049,
    boundsNeLng: 13.0651259,
    boundsSwLat: 56.4916209,
    boundsSwLng: 13.0074661,
    centerLat: 56.5057557,
    centerLng: 13.0456048,
    code: 1381,
    name: "Laholm",
    population: 24664.0,
    populationDensity: 27.94,
  },
  {
    admin: "Hallands län",
    area: 1825.9,
    areaLake: 47.81,
    areaLand: 1108.53,
    areaSea: 669.38,
    boundsNeLat: 56.935332,
    boundsNeLng: 12.585301,
    boundsSwLat: 56.861647,
    boundsSwLng: 12.4059,
    centerLat: 56.9027333,
    centerLng: 12.4888013,
    code: 1382,
    name: "Falkenberg",
    population: 43867.0,
    populationDensity: 39.57,
  },
  {
    admin: "Hallands län",
    area: 1703.46,
    areaLake: 41.03,
    areaLand: 868.62,
    areaSea: 793.71,
    boundsNeLat: 57.11013958,
    boundsNeLng: 12.25583208,
    boundsSwLat: 57.10744162,
    boundsSwLng: 12.25313412,
    centerLat: 57.1087906,
    centerLng: 12.2544831,
    code: 1383,
    name: "Varberg",
    population: 61868.0,
    populationDensity: 71.23,
  },
  {
    admin: "Hallands län",
    area: 1472.93,
    areaLake: 35.17,
    areaLand: 606.6,
    areaSea: 831.17,
    boundsNeLat: 57.5039972,
    boundsNeLng: 12.0837738,
    boundsSwLat: 57.5031332,
    boundsSwLng: 12.0810775,
    centerLat: 57.5035562,
    centerLng: 12.0823342,
    code: 1384,
    name: "Kungsbacka",
    population: 80442.0,
    populationDensity: 132.61,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 291.66,
    areaLake: 24.96,
    areaLand: 266.7,
    areaSea: 0.0,
    boundsNeLat: 57.7393089,
    boundsNeLng: 12.565781,
    boundsSwLat: 57.588192,
    boundsSwLng: 12.0672281,
    centerLat: 57.660155,
    centerLng: 12.2915063,
    code: 1401,
    name: "H\u00e4rryda",
    population: 37108.0,
    populationDensity: 139.14,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 58.41,
    areaLake: 1.61,
    areaLand: 56.8,
    areaSea: 0.0,
    boundsNeLat: 57.774382,
    boundsNeLng: 12.168854,
    boundsSwLat: 57.7293309,
    boundsSwLng: 12.0923229,
    centerLat: 57.7366497,
    centerLng: 12.1251968,
    code: 1402,
    name: "Partille",
    population: 37316.0,
    populationDensity: 656.97,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 511.42,
    areaLake: 0.13,
    areaLand: 25.75,
    areaSea: 485.53,
    boundsNeLat: 57.8039719,
    boundsNeLng: 11.713709,
    boundsSwLat: 57.6534621,
    boundsSwLng: 11.5190691,
    centerLat: 57.711741,
    centerLng: 11.6487886,
    code: 1407,
    name: "\u00d6cker\u00f6",
    population: 12773.0,
    populationDensity: 496.04,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 301.05,
    areaLake: 14.02,
    areaLand: 251.87,
    areaSea: 35.21,
    boundsNeLat: 58.103684,
    boundsNeLng: 11.890088,
    boundsSwLat: 58.038663,
    boundsSwLng: 11.7985215,
    centerLat: 58.0678388,
    centerLng: 11.8294346,
    code: 1415,
    name: "Stenungsund",
    population: 25815.0,
    populationDensity: 102.49,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 845.93,
    areaLake: 0.79,
    areaLand: 167.36,
    areaSea: 677.8,
    boundsNeLat: 58.0972847,
    boundsNeLng: 11.7974173,
    boundsSwLat: 57.906848,
    boundsSwLng: 11.4397657,
    centerLat: 58.0410195,
    centerLng: 11.6836708,
    code: 1419,
    name: "Tj\u00f6rn",
    population: 15584.0,
    populationDensity: 93.12,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 883.11,
    areaLake: 4.54,
    areaLand: 386.49,
    areaSea: 491.96,
    boundsNeLat: 58.3125169,
    boundsNeLng: 11.8641609,
    boundsSwLat: 58.0564579,
    boundsSwLng: 11.3256901,
    centerLat: 58.1866415,
    centerLng: 11.6069189,
    code: 1421,
    name: "Orust",
    population: 15093.0,
    populationDensity: 39.05,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 684.37,
    areaLake: 1.23,
    areaLand: 138.2,
    areaSea: 544.94,
    boundsNeLat: 58.502153,
    boundsNeLng: 11.4629181,
    boundsSwLat: 58.2854732,
    boundsSwLng: 11.1821058,
    centerLat: 58.4401392,
    centerLng: 11.3614392,
    code: 1427,
    name: "Soten\u00e4s",
    population: 9065.0,
    populationDensity: 65.59,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 675.04,
    areaLake: 33.67,
    areaLand: 634.02,
    areaSea: 7.33,
    boundsNeLat: 58.4954021,
    boundsNeLng: 11.71191,
    boundsSwLat: 58.449742,
    boundsSwLng: 11.6544327,
    centerLat: 58.4715051,
    centerLng: 11.6801923,
    code: 1430,
    name: "Munkedal",
    population: 10361.0,
    populationDensity: 16.34,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 2351.37,
    areaLake: 37.63,
    areaLand: 917.21,
    areaSea: 1396.53,
    boundsNeLat: 58.910364,
    boundsNeLng: 11.7611478,
    boundsSwLat: 58.476428,
    boundsSwLng: 11.0617413,
    centerLat: 58.7327267,
    centerLng: 11.4578192,
    code: 1435,
    name: "Tanum",
    population: 12606.0,
    populationDensity: 13.74,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 825.43,
    areaLake: 101.12,
    areaLand: 724.31,
    areaSea: 0.0,
    boundsNeLat: 59.2575091,
    boundsNeLng: 12.1578899,
    boundsSwLat: 58.750376,
    boundsSwLng: 11.6143729,
    centerLat: 58.9743879,
    centerLng: 11.8651749,
    code: 1438,
    name: "Dals-Ed",
    population: 4777.0,
    populationDensity: 6.6,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 618.32,
    areaLake: 29.34,
    areaLand: 588.98,
    areaSea: 0.0,
    boundsNeLat: 58.6524456,
    boundsNeLng: 12.0560607,
    boundsSwLat: 58.6505114,
    boundsSwLng: 12.05402,
    centerLat: 58.6513706,
    centerLng: 12.0548287,
    code: 1439,
    name: "F\u00e4rgelanda",
    population: 6627.0,
    populationDensity: 11.25,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 332.13,
    areaLake: 15.12,
    areaLand: 317.01,
    areaSea: 0.0,
    boundsNeLat: 58.1137351,
    boundsNeLng: 12.4445669,
    boundsSwLat: 57.8067941,
    boundsSwLng: 12.0055011,
    centerLat: 57.988605,
    centerLng: 12.2344546,
    code: 1440,
    name: "Ale",
    population: 29549.0,
    populationDensity: 93.21,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 308.41,
    areaLake: 49.86,
    areaLand: 258.55,
    areaSea: 0.0,
    boundsNeLat: 57.77113728,
    boundsNeLng: 12.27099938,
    boundsSwLat: 57.76843932,
    boundsSwLng: 12.26830142,
    centerLat: 57.7697883,
    centerLng: 12.2696504,
    code: 1441,
    name: "Lerum",
    population: 40692.0,
    populationDensity: 157.39,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 441.24,
    areaLake: 14.66,
    areaLand: 426.58,
    areaSea: 0.0,
    boundsNeLat: 59.2620341,
    boundsNeLng: 14.7148173,
    boundsSwLat: 57.14008,
    boundsSwLng: 10.9631866,
    centerLat: 58.2527926,
    centerLng: 13.0596425,
    code: 1442,
    name: "V\u00e5rg\u00e5rda",
    population: 11295.0,
    populationDensity: 26.48,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 282.39,
    areaLake: 19.23,
    areaLand: 263.16,
    areaSea: 0.0,
    boundsNeLat: 57.653409,
    boundsNeLng: 12.6190536,
    boundsSwLat: 57.554222,
    boundsSwLng: 12.5226181,
    centerLat: 57.6005306,
    centerLng: 12.5891024,
    code: 1443,
    name: "Bollebygd",
    population: 9102.0,
    populationDensity: 34.59,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 280.65,
    areaLake: 1.17,
    areaLand: 264.64,
    areaSea: 0.0,
    boundsNeLat: 58.3428211,
    boundsNeLng: 12.6946609,
    boundsSwLat: 58.3220511,
    boundsSwLng: 12.66534,
    centerLat: 58.3340403,
    centerLng: 12.6802177,
    code: 1444,
    name: "Gr\u00e4storp",
    population: 5721.0,
    populationDensity: 21.62,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 235.68,
    areaLake: 1.1,
    areaLand: 234.58,
    areaSea: 0.0,
    boundsNeLat: 59.2620341,
    boundsNeLng: 14.7148173,
    boundsSwLat: 57.14008,
    boundsSwLng: 10.9631866,
    centerLat: 58.2527926,
    centerLng: 13.0596425,
    code: 1445,
    name: "Essunga",
    population: 5620.0,
    populationDensity: 23.96,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 797.32,
    areaLake: 77.27,
    areaLand: 405.82,
    areaSea: 0.0,
    boundsNeLat: 58.55556838,
    boundsNeLng: 14.01487198,
    boundsSwLat: 58.55287042,
    boundsSwLng: 14.01217402,
    centerLat: 58.5542194,
    centerLng: 14.013523,
    code: 1446,
    name: "Karlsborg",
    population: 6913.0,
    populationDensity: 17.03,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 554.95,
    areaLake: 69.08,
    areaLand: 315.44,
    areaSea: 0.0,
    boundsNeLat: 58.9902571,
    boundsNeLng: 14.1240561,
    boundsSwLat: 58.974238,
    boundsSwLng: 14.0771162,
    centerLat: 58.985467,
    centerLng: 14.096623,
    code: 1447,
    name: "Gullsp\u00e5ng",
    population: 5307.0,
    populationDensity: 16.82,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 778.48,
    areaLake: 37.28,
    areaLand: 741.2,
    areaSea: 0.0,
    boundsNeLat: 57.48525888,
    boundsNeLng: 13.35211948,
    boundsSwLat: 57.48256092,
    boundsSwLng: 13.34942152,
    centerLat: 57.4839099,
    centerLng: 13.3507705,
    code: 1452,
    name: "Tranemo",
    population: 11776.0,
    populationDensity: 15.89,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 1059.18,
    areaLake: 176.2,
    areaLand: 882.98,
    areaSea: 0.0,
    boundsNeLat: 59.048552,
    boundsNeLng: 12.2483019,
    boundsSwLat: 59.013731,
    boundsSwLng: 12.1865241,
    centerLat: 59.028612,
    centerLng: 12.226943,
    code: 1460,
    name: "Bengtsfors",
    population: 9940.0,
    populationDensity: 11.26,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 944.46,
    areaLake: 47.62,
    areaLand: 513.74,
    areaSea: 0.0,
    boundsNeLat: 58.7044745,
    boundsNeLng: 12.4684864,
    boundsSwLat: 58.6928805,
    boundsSwLng: 12.4364716,
    centerLat: 58.698678,
    centerLng: 12.452479,
    code: 1461,
    name: "Mellerud",
    population: 9323.0,
    populationDensity: 18.15,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 341.79,
    areaLake: 26.15,
    areaLand: 315.64,
    areaSea: 0.0,
    boundsNeLat: 58.147245,
    boundsNeLng: 12.1483892,
    boundsSwLat: 58.117071,
    boundsSwLng: 12.1001771,
    centerLat: 58.132158,
    centerLng: 12.1241336,
    code: 1462,
    name: "Lilla Edet",
    population: 13728.0,
    populationDensity: 43.49,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 1013.2,
    areaLake: 84.0,
    areaLand: 929.2,
    areaSea: 0.0,
    boundsNeLat: 57.633062,
    boundsNeLng: 12.9576719,
    boundsSwLat: 57.2652921,
    boundsSwLng: 12.250487,
    centerLat: 57.4253176,
    centerLng: 12.5695216,
    code: 1463,
    name: "Mark",
    population: 34218.0,
    populationDensity: 36.83,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 987.14,
    areaLake: 67.46,
    areaLand: 919.68,
    areaSea: 0.0,
    boundsNeLat: 57.510678,
    boundsNeLng: 13.1321549,
    boundsSwLat: 57.481103,
    boundsSwLng: 13.0833219,
    centerLat: 57.4955715,
    centerLng: 13.1146225,
    code: 1465,
    name: "Svenljunga",
    population: 10679.0,
    populationDensity: 11.61,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 509.52,
    areaLake: 12.04,
    areaLand: 497.48,
    areaSea: 0.0,
    boundsNeLat: 58.07841678,
    boundsNeLng: 13.02814618,
    boundsSwLat: 58.07571882,
    boundsSwLng: 13.02544822,
    centerLat: 58.0770678,
    centerLng: 13.0267972,
    code: 1466,
    name: "Herrljunga",
    population: 9486.0,
    populationDensity: 19.07,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 700.65,
    areaLake: 3.72,
    areaLand: 696.93,
    areaSea: 0.0,
    boundsNeLat: 58.2714361,
    boundsNeLng: 12.978812,
    boundsSwLat: 58.2537559,
    boundsSwLng: 12.9375729,
    centerLat: 58.261781,
    centerLng: 12.960194,
    code: 1470,
    name: "Vara",
    population: 15788.0,
    populationDensity: 22.65,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 620.71,
    areaLake: 0.93,
    areaLand: 404.51,
    areaSea: 0.0,
    boundsNeLat: 58.536836,
    boundsNeLng: 13.5187669,
    boundsSwLat: 58.5116459,
    boundsSwLng: 13.4436919,
    centerLat: 58.528002,
    centerLng: 13.491428,
    code: 1471,
    name: "G\u00f6tene",
    population: 13275.0,
    populationDensity: 32.82,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 235.2,
    areaLake: 15.4,
    areaLand: 219.8,
    areaSea: 0.0,
    boundsNeLat: 58.4320959,
    boundsNeLng: 14.1968279,
    boundsSwLat: 58.4011629,
    boundsSwLng: 14.119229,
    centerLat: 58.424323,
    centerLng: 14.1616418,
    code: 1472,
    name: "Tibro",
    population: 11070.0,
    populationDensity: 50.36,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 591.14,
    areaLake: 50.45,
    areaLand: 540.69,
    areaSea: 0.0,
    boundsNeLat: 58.7220369,
    boundsNeLng: 14.1545551,
    boundsSwLat: 58.6909401,
    boundsSwLng: 14.1088791,
    centerLat: 58.7055092,
    centerLng: 14.1261468,
    code: 1473,
    name: "T\u00f6reboda",
    population: 9435.0,
    populationDensity: 17.45,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 1024.04,
    areaLake: 14.21,
    areaLand: 447.88,
    areaSea: 563.28,
    boundsNeLat: 57.6526376,
    boundsNeLng: 11.9454514,
    boundsSwLat: 57.6406954,
    boundsSwLng: 11.9134366,
    centerLat: 57.646667,
    centerLng: 11.929444,
    code: 1480,
    name: "G\u00f6teborg",
    population: 556640.0,
    populationDensity: 1242.83,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 152.28,
    areaLake: 6.44,
    areaLand: 145.84,
    areaSea: 0.0,
    boundsNeLat: 57.6914934,
    boundsNeLng: 12.0066848,
    boundsSwLat: 57.6764804,
    boundsSwLng: 11.9913829,
    centerLat: 57.6841241,
    centerLng: 11.999811,
    code: 1481,
    name: "M\u00f6lndal",
    population: 64465.0,
    populationDensity: 442.03,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 682.57,
    areaLake: 8.38,
    areaLand: 362.45,
    areaSea: 311.6,
    boundsNeLat: 58.2784766,
    boundsNeLng: 12.2716042,
    boundsSwLat: 58.2719738,
    boundsSwLng: 12.2495703,
    centerLat: 58.2772609,
    centerLng: 12.2596732,
    code: 1482,
    name: "Kung\u00e4lv",
    population: 43289.0,
    populationDensity: 119.43,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 695.42,
    areaLake: 0.85,
    areaLand: 208.45,
    areaSea: 486.11,
    boundsNeLat: 58.2919169,
    boundsNeLng: 11.4768472,
    boundsSwLat: 58.2673945,
    boundsSwLng: 11.4183488,
    centerLat: 58.275573,
    centerLng: 11.435558,
    code: 1484,
    name: "Lysekil",
    population: 14570.0,
    populationDensity: 69.9,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 733.05,
    areaLake: 12.65,
    areaLand: 637.66,
    areaSea: 82.72,
    boundsNeLat: 58.382303,
    boundsNeLng: 12.0143339,
    boundsSwLat: 58.322688,
    boundsSwLng: 11.865948,
    centerLat: 58.3498003,
    centerLng: 11.935649,
    code: 1485,
    name: "Uddevalla",
    population: 55164.0,
    populationDensity: 86.51,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 951.84,
    areaLake: 10.13,
    areaLand: 467.47,
    areaSea: 474.24,
    boundsNeLat: 58.3537104,
    boundsNeLng: 11.9327617,
    boundsSwLat: 58.3519013,
    boundsSwLng: 11.9160773,
    centerLat: 58.3527396,
    centerLng: 11.9242665,
    code: 1486,
    name: "Str\u00f6mstad",
    population: 13079.0,
    populationDensity: 27.98,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 898.83,
    areaLake: 23.02,
    areaLand: 642.6,
    areaSea: 0.0,
    boundsNeLat: 58.3319379,
    boundsNeLng: 12.2936179,
    boundsSwLat: 58.2867996,
    boundsSwLng: 12.2665924,
    centerLat: 58.3117155,
    centerLng: 12.2918706,
    code: 1487,
    name: "V\u00e4nersborg",
    population: 38955.0,
    populationDensity: 60.62,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 427.71,
    areaLake: 17.85,
    areaLand: 409.86,
    areaSea: 0.0,
    boundsNeLat: 58.332091,
    boundsNeLng: 12.3647059,
    boundsSwLat: 58.244792,
    boundsSwLng: 12.2400791,
    centerLat: 58.2834894,
    centerLng: 12.2858206,
    code: 1488,
    name: "Trollh\u00e4ttan",
    population: 57753.0,
    populationDensity: 140.91,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 551.16,
    areaLake: 79.16,
    areaLand: 472.0,
    areaSea: 0.0,
    boundsNeLat: 58.0869811,
    boundsNeLng: 12.817512,
    boundsSwLat: 57.7928401,
    boundsSwLng: 12.3760749,
    centerLat: 57.9799652,
    centerLng: 12.5557707,
    code: 1489,
    name: "Alings\u00e5s",
    population: 40045.0,
    populationDensity: 84.84,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 967.53,
    areaLake: 57.65,
    areaLand: 909.88,
    areaSea: 0.0,
    boundsNeLat: 57.5121391,
    boundsNeLng: 13.1120116,
    boundsSwLat: 57.496565,
    boundsSwLng: 13.1079961,
    centerLat: 57.5044942,
    centerLng: 13.1104746,
    code: 1490,
    name: "Bor\u00e5s",
    population: 109880.0,
    populationDensity: 120.76,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 1116.89,
    areaLake: 70.86,
    areaLand: 1046.03,
    areaSea: 0.0,
    boundsNeLat: 59.2620341,
    boundsNeLng: 14.7148173,
    boundsSwLat: 57.14008,
    boundsSwLng: 10.9631866,
    centerLat: 58.2527926,
    centerLng: 13.0596425,
    code: 1491,
    name: "Ulricehamn",
    population: 23887.0,
    populationDensity: 22.84,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 889.72,
    areaLake: 52.39,
    areaLand: 481.11,
    areaSea: 0.0,
    boundsNeLat: 59.0759221,
    boundsNeLng: 12.723915,
    boundsSwLat: 59.027336,
    boundsSwLng: 12.6741189,
    centerLat: 59.051117,
    centerLng: 12.6977323,
    code: 1492,
    name: "\u00c5m\u00e5l",
    population: 12801.0,
    populationDensity: 26.61,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 1503.24,
    areaLake: 10.93,
    areaLand: 602.47,
    areaSea: 0.0,
    boundsNeLat: 58.71113968,
    boundsNeLng: 13.82310508,
    boundsSwLat: 58.70844172,
    boundsSwLng: 13.82040712,
    centerLat: 58.7097907,
    centerLng: 13.8217561,
    code: 1493,
    name: "Mariestad",
    population: 24215.0,
    populationDensity: 40.19,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 1372.6,
    areaLake: 2.68,
    areaLand: 698.63,
    areaSea: 0.0,
    boundsNeLat: 58.546194,
    boundsNeLng: 13.2126519,
    boundsSwLat: 58.474168,
    boundsSwLng: 13.0831159,
    centerLat: 58.5035047,
    centerLng: 13.1570768,
    code: 1494,
    name: "Lidk\u00f6ping",
    population: 39235.0,
    populationDensity: 56.16,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 448.69,
    areaLake: 20.07,
    areaLand: 428.62,
    areaSea: 0.0,
    boundsNeLat: 58.38867228,
    boundsNeLng: 13.44141018,
    boundsSwLat: 58.38597432,
    boundsSwLng: 13.43871222,
    centerLat: 58.3873233,
    centerLng: 13.4400612,
    code: 1495,
    name: "Skara",
    population: 18979.0,
    populationDensity: 44.28,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 685.08,
    areaLake: 11.4,
    areaLand: 673.68,
    areaSea: 0.0,
    boundsNeLat: 58.437518,
    boundsNeLng: 13.9103311,
    boundsSwLat: 58.3630159,
    boundsSwLng: 13.8094438,
    centerLat: 58.3902782,
    centerLng: 13.8461208,
    code: 1496,
    name: "Sk\u00f6vde",
    population: 54133.0,
    populationDensity: 80.35,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 584.47,
    areaLake: 5.09,
    areaLand: 297.04,
    areaSea: 0.0,
    boundsNeLat: 58.3985911,
    boundsNeLng: 13.9252947,
    boundsSwLat: 58.3952239,
    boundsSwLng: 13.8815525,
    centerLat: 58.3984771,
    centerLng: 13.9030062,
    code: 1497,
    name: "Hjo",
    population: 9048.0,
    populationDensity: 30.46,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 522.94,
    areaLake: 4.96,
    areaLand: 517.98,
    areaSea: 0.0,
    boundsNeLat: 57.9245226,
    boundsNeLng: 13.8825699,
    boundsSwLat: 57.9135853,
    boundsSwLng: 13.8716609,
    centerLat: 57.9191645,
    centerLng: 13.8777292,
    code: 1498,
    name: "Tidaholm",
    population: 12797.0,
    populationDensity: 24.71,
  },
  {
    admin: "V\u00e4stra G\u00f6talands län",
    area: 1065.77,
    areaLake: 20.89,
    areaLand: 1044.88,
    areaSea: 0.0,
    boundsNeLat: 58.19667,
    boundsNeLng: 13.5928939,
    boundsSwLat: 58.144402,
    boundsSwLng: 13.512542,
    centerLat: 58.175029,
    centerLng: 13.553217,
    code: 1499,
    name: "Falk\u00f6ping",
    population: 32806.0,
    populationDensity: 31.4,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 406.87,
    areaLake: 47.15,
    areaLand: 359.72,
    areaSea: 0.0,
    boundsNeLat: 59.50469948,
    boundsNeLng: 13.31892088,
    boundsSwLat: 59.50200152,
    boundsSwLng: 13.31622292,
    centerLat: 59.5033505,
    centerLng: 13.3175719,
    code: 1715,
    name: "Kil",
    population: 11800.0,
    populationDensity: 32.8,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 894.93,
    areaLake: 74.75,
    areaLand: 820.18,
    areaSea: 0.0,
    boundsNeLat: 59.8386627,
    boundsNeLng: 12.3326744,
    boundsSwLat: 59.8274484,
    boundsSwLng: 12.3006596,
    centerLat: 59.833056,
    centerLng: 12.316667,
    code: 1730,
    name: "Eda",
    population: 8526.0,
    populationDensity: 10.4,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 4357.42,
    areaLake: 195.21,
    areaLand: 4162.21,
    areaSea: 0.0,
    boundsNeLat: 60.656962,
    boundsNeLng: 13.4708468,
    boundsSwLat: 60.0140351,
    boundsSwLng: 12.460801,
    centerLat: 60.1835706,
    centerLng: 12.9319421,
    code: 1737,
    name: "Torsby",
    population: 12169.0,
    populationDensity: 2.92,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 472.71,
    areaLake: 81.03,
    areaLand: 391.68,
    areaSea: 0.0,
    boundsNeLat: 59.5510509,
    boundsNeLng: 14.2936792,
    boundsSwLat: 59.523902,
    boundsSwLng: 14.2566111,
    centerLat: 59.5332079,
    centerLng: 14.2722085,
    code: 1760,
    name: "Storfors",
    population: 4046.0,
    populationDensity: 10.33,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 464.15,
    areaLake: 0.9,
    areaLand: 59.44,
    areaSea: 0.0,
    boundsNeLat: 59.3659339,
    boundsNeLng: 13.7039031,
    boundsSwLat: 59.250805,
    boundsSwLng: 13.4123701,
    centerLat: 59.289306,
    centerLng: 13.5177132,
    code: 1761,
    name: "Hammar\u00f6",
    population: 15725.0,
    populationDensity: 264.55,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 147.97,
    areaLake: 6.39,
    areaLand: 141.58,
    areaSea: 0.0,
    boundsNeLat: 59.3834583,
    boundsNeLng: 13.5185957,
    boundsSwLat: 59.382169,
    boundsSwLng: 13.5161688,
    centerLat: 59.3827781,
    centerLng: 13.5176245,
    code: 1762,
    name: "Munkfors",
    population: 3738.0,
    populationDensity: 26.4,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 397.29,
    areaLake: 49.13,
    areaLand: 348.16,
    areaSea: 0.0,
    boundsNeLat: 59.52880328,
    boundsNeLng: 13.49059838,
    boundsSwLat: 59.52610532,
    boundsSwLng: 13.48790042,
    centerLat: 59.5274543,
    centerLng: 13.4892494,
    code: 1763,
    name: "Forshaga",
    population: 11451.0,
    populationDensity: 32.89,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 478.81,
    areaLake: 47.87,
    areaLand: 386.36,
    areaSea: 0.0,
    boundsNeLat: 59.3724261,
    boundsNeLng: 13.1308061,
    boundsSwLat: 59.312291,
    boundsSwLng: 13.0818034,
    centerLat: 59.3531787,
    centerLng: 13.1117319,
    code: 1764,
    name: "Grum",
    population: 9063.0,
    populationDensity: 23.46,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 1653.04,
    areaLake: 243.6,
    areaLand: 1409.44,
    areaSea: 0.0,
    boundsNeLat: 59.402859,
    boundsNeLng: 12.1648531,
    boundsSwLat: 59.3672679,
    boundsSwLng: 12.103345,
    centerLat: 59.3891592,
    centerLng: 12.132717,
    code: 1765,
    name: "\u00c5rj\u00e4ng",
    population: 9958.0,
    populationDensity: 7.07,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 1448.25,
    areaLake: 160.23,
    areaLand: 1288.02,
    areaSea: 0.0,
    boundsNeLat: 59.8543009,
    boundsNeLng: 13.1638959,
    boundsSwLat: 59.8222724,
    boundsSwLng: 13.12341,
    centerLat: 59.8365575,
    centerLng: 13.1440464,
    code: 1766,
    name: "Sunne",
    population: 13425.0,
    populationDensity: 10.42,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 1517.74,
    areaLake: 73.89,
    areaLand: 1168.66,
    areaSea: 0.0,
    boundsNeLat: 59.38076088,
    boundsNeLng: 13.49693258,
    boundsSwLat: 59.37806292,
    boundsSwLng: 13.49423462,
    centerLat: 59.3794119,
    centerLng: 13.4955836,
    code: 1780,
    name: "Karlstad",
    population: 90198.0,
    populationDensity: 77.18,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 1384.43,
    areaLake: 40.66,
    areaLand: 755.2,
    areaSea: 0.0,
    boundsNeLat: 59.554862,
    boundsNeLng: 14.3613209,
    boundsSwLat: 59.002242,
    boundsSwLng: 13.7777539,
    centerLat: 59.2314721,
    centerLng: 14.1604548,
    code: 1781,
    name: "Kristinehamn",
    population: 24671.0,
    populationDensity: 32.67,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 1711.71,
    areaLake: 177.67,
    areaLand: 1534.04,
    areaSea: 0.0,
    boundsNeLat: 59.731068,
    boundsNeLng: 14.2008521,
    boundsSwLat: 59.6874331,
    boundsSwLng: 14.133836,
    centerLat: 59.7139973,
    centerLng: 14.1698445,
    code: 1782,
    name: "Filipstad",
    population: 10960.0,
    populationDensity: 7.14,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 2000.15,
    areaLake: 175.96,
    areaLand: 1824.19,
    areaSea: 0.0,
    boundsNeLat: 60.03276268,
    boundsNeLng: 13.70349078,
    boundsSwLat: 60.03006472,
    boundsSwLng: 13.70079282,
    centerLat: 60.0314137,
    centerLng: 13.7021418,
    code: 1783,
    name: "Hagfors",
    population: 11917.0,
    populationDensity: 6.53,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 1956.13,
    areaLake: 307.1,
    areaLand: 1649.03,
    areaSea: 0.0,
    boundsNeLat: 59.762078,
    boundsNeLng: 12.7258871,
    boundsSwLat: 59.5627009,
    boundsSwLng: 12.162078,
    centerLat: 59.6424649,
    centerLng: 12.4570024,
    code: 1784,
    name: "Arvika",
    population: 26054.0,
    populationDensity: 15.8,
  },
  {
    admin: "V\u00e4rmlands län",
    area: 2497.51,
    areaLake: 97.37,
    areaLand: 1220.88,
    areaSea: 0.0,
    boundsNeLat: 59.285767,
    boundsNeLng: 12.9374739,
    boundsSwLat: 59.097339,
    boundsSwLng: 12.4166587,
    centerLat: 59.1915076,
    centerLng: 12.7599042,
    code: 1785,
    name: "S\u00e4ffle",
    population: 15633.0,
    populationDensity: 12.8,
  },
  {
    admin: "\u00d6rebro län",
    area: 481.67,
    areaLake: 18.51,
    areaLand: 463.16,
    areaSea: 0.0,
    boundsNeLat: 59.341715,
    boundsNeLng: 15.063121,
    boundsSwLat: 59.046314,
    boundsSwLng: 14.5226229,
    centerLat: 59.1653904,
    centerLng: 14.7434068,
    code: 1814,
    name: "Lekeberg",
    population: 7636.0,
    populationDensity: 16.49,
  },
  {
    admin: "\u00d6rebro län",
    area: 737.56,
    areaLake: 135.56,
    areaLand: 602.0,
    areaSea: 0.0,
    boundsNeLat: 59.1158679,
    boundsNeLng: 14.840704,
    boundsSwLat: 58.846124,
    boundsSwLng: 14.4716149,
    centerLat: 58.9896252,
    centerLng: 14.6388738,
    code: 1860,
    name: "Lax\u00e5",
    population: 5709.0,
    populationDensity: 9.48,
  },
  {
    admin: "\u00d6rebro län",
    area: 670.22,
    areaLake: 33.51,
    areaLand: 636.71,
    areaSea: 0.0,
    boundsNeLat: 59.06672298,
    boundsNeLng: 15.10636938,
    boundsSwLat: 59.06402502,
    boundsSwLng: 15.10367142,
    centerLat: 59.065374,
    centerLng: 15.1050204,
    code: 1861,
    name: "Hallsberg",
    population: 15649.0,
    populationDensity: 24.58,
  },
  {
    admin: "\u00d6rebro län",
    area: 433.71,
    areaLake: 49.76,
    areaLand: 383.95,
    areaSea: 0.0,
    boundsNeLat: 59.2595339,
    boundsNeLng: 14.4588331,
    boundsSwLat: 59.2134479,
    boundsSwLng: 14.3971351,
    centerLat: 59.2391027,
    centerLng: 14.4339179,
    code: 1862,
    name: "Degerfor",
    population: 9609.0,
    populationDensity: 25.03,
  },
  {
    admin: "\u00d6rebro län",
    area: 1151.26,
    areaLake: 166.3,
    areaLand: 984.96,
    areaSea: 0.0,
    boundsNeLat: 59.800914,
    boundsNeLng: 14.5417381,
    boundsSwLat: 59.76799,
    boundsSwLng: 14.4868459,
    centerLat: 59.783688,
    centerLng: 14.5225692,
    code: 1863,
    name: "H\u00e4llefors",
    population: 7138.0,
    populationDensity: 7.25,
  },
  {
    admin: "\u00d6rebro län",
    area: 631.1,
    areaLake: 55.56,
    areaLand: 575.54,
    areaSea: 0.0,
    boundsNeLat: 60.1056601,
    boundsNeLng: 15.239447,
    boundsSwLat: 59.7461571,
    boundsSwLng: 14.6847442,
    centerLat: 59.9752934,
    centerLng: 14.8777794,
    code: 1864,
    name: "Ljusnarsberg",
    population: 5006.0,
    populationDensity: 8.7,
  },
  {
    admin: "\u00d6rebro län",
    area: 1620.59,
    areaLake: 50.6,
    areaLand: 1373.02,
    areaSea: 0.0,
    boundsNeLat: 59.32867,
    boundsNeLng: 15.2804088,
    boundsSwLat: 59.227477,
    boundsSwLng: 15.1245001,
    centerLat: 59.2752626,
    centerLng: 15.2134105,
    code: 1880,
    name: "\u00d6rebro",
    population: 146631.0,
    populationDensity: 106.79,
  },
  {
    admin: "\u00d6rebro län",
    area: 205.79,
    areaLake: 1.59,
    areaLand: 204.2,
    areaSea: 0.0,
    boundsNeLat: 59.145353,
    boundsNeLng: 15.1691279,
    boundsSwLat: 59.1053329,
    boundsSwLng: 15.111641,
    centerLat: 59.1265359,
    centerLng: 15.1401053,
    code: 1881,
    name: "Kumla",
    population: 21334.0,
    populationDensity: 104.48,
  },
  {
    admin: "\u00d6rebro län",
    area: 1019.74,
    areaLake: 60.91,
    areaLand: 816.46,
    areaSea: 0.0,
    boundsNeLat: 58.9010429,
    boundsNeLng: 14.926394,
    boundsSwLat: 58.8766011,
    boundsSwLng: 14.8942199,
    centerLat: 58.8894268,
    centerLng: 14.9109867,
    code: 1882,
    name: "Askersund",
    population: 11282.0,
    populationDensity: 13.82,
  },
  {
    admin: "\u00d6rebro län",
    area: 510.36,
    areaLake: 42.12,
    areaLand: 468.24,
    areaSea: 0.0,
    boundsNeLat: 59.3728809,
    boundsNeLng: 14.613586,
    boundsSwLat: 59.295808,
    boundsSwLng: 14.4501969,
    centerLat: 59.328634,
    centerLng: 14.536414,
    code: 1883,
    name: "Karlskoga",
    population: 30538.0,
    populationDensity: 65.22,
  },
  {
    admin: "\u00d6rebro län",
    area: 690.82,
    areaLake: 72.28,
    areaLand: 618.54,
    areaSea: 0.0,
    boundsNeLat: 59.540297,
    boundsNeLng: 15.045659,
    boundsSwLat: 59.486875,
    boundsSwLng: 14.9936099,
    centerLat: 59.5192064,
    centerLng: 15.0378667,
    code: 1884,
    name: "Nora",
    population: 10665.0,
    populationDensity: 17.24,
  },
  {
    admin: "\u00d6rebro län",
    area: 1480.5,
    areaLake: 102.9,
    areaLand: 1377.6,
    areaSea: 0.0,
    boundsNeLat: 59.5972573,
    boundsNeLng: 15.2450074,
    boundsSwLat: 59.5859618,
    boundsSwLng: 15.2129926,
    centerLat: 59.59161,
    centerLng: 15.229,
    code: 1885,
    name: "Lindesberg",
    population: 23744.0,
    populationDensity: 17.24,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 718.18,
    areaLake: 58.76,
    areaLand: 659.42,
    areaSea: 0.0,
    boundsNeLat: 59.83172648,
    boundsNeLng: 15.68377748,
    boundsSwLat: 59.82902852,
    boundsSwLng: 15.68107952,
    centerLat: 59.8303775,
    centerLng: 15.6824285,
    code: 1904,
    name: "Skinnskatteberg",
    population: 4429.0,
    populationDensity: 6.72,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 368.99,
    areaLake: 25.09,
    areaLand: 343.9,
    areaSea: 0.0,
    boundsNeLat: 59.722123,
    boundsNeLng: 16.2481,
    boundsSwLat: 59.689157,
    boundsSwLng: 16.1918181,
    centerLat: 59.7072262,
    centerLng: 16.2268409,
    code: 1907,
    name: "Surahammar",
    population: 10059.0,
    populationDensity: 29.25,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 227.13,
    areaLake: 0.93,
    areaLand: 202.62,
    areaSea: 0.0,
    boundsNeLat: 59.42396808,
    boundsNeLng: 16.09898488,
    boundsSwLat: 59.42127012,
    boundsSwLng: 16.09628692,
    centerLat: 59.4226191,
    centerLng: 16.0976359,
    code: 1960,
    name: "Kungs\u00f6r",
    population: 8432.0,
    populationDensity: 41.61,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 180.26,
    areaLake: 1.76,
    areaLand: 169.53,
    areaSea: 0.0,
    boundsNeLat: 59.631391,
    boundsNeLng: 16.262175,
    boundsSwLat: 59.5933559,
    boundsSwLng: 16.1949461,
    centerLat: 59.6132041,
    centerLng: 16.2294755,
    code: 1961,
    name: "Hallstahammar",
    population: 15843.0,
    populationDensity: 93.45,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 447.69,
    areaLake: 29.83,
    areaLand: 417.86,
    areaSea: 0.0,
    boundsNeLat: 60.06670918,
    boundsNeLng: 15.92554998,
    boundsSwLat: 60.06401122,
    boundsSwLng: 15.92285202,
    centerLat: 60.0653602,
    centerLng: 15.924201,
    code: 1962,
    name: "Norberg",
    population: 5795.0,
    populationDensity: 13.87,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 1137.82,
    areaLake: 4.18,
    areaLand: 958.83,
    areaSea: 0.0,
    boundsNeLat: 59.676659,
    boundsNeLng: 16.6539362,
    boundsSwLat: 59.572525,
    boundsSwLng: 16.4362452,
    centerLat: 59.6099005,
    centerLng: 16.5448091,
    code: 1980,
    name: "V\u00e4ster\u00e5s",
    population: 147420.0,
    populationDensity: 153.75,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 1204.37,
    areaLake: 37.54,
    areaLand: 1166.83,
    areaSea: 0.0,
    boundsNeLat: 59.92158898,
    boundsNeLng: 16.60785398,
    boundsSwLat: 59.91889102,
    boundsSwLng: 16.60515602,
    centerLat: 59.92024,
    centerLng: 16.606505,
    code: 1981,
    name: "Sala",
    population: 22353.0,
    populationDensity: 19.16,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 310.4,
    areaLake: 41.37,
    areaLand: 269.03,
    areaSea: 0.0,
    boundsNeLat: 60.025489,
    boundsNeLng: 15.8470908,
    boundsSwLat: 59.9711851,
    boundsSwLng: 15.7493418,
    centerLat: 59.989144,
    centerLng: 15.8166418,
    code: 1982,
    name: "Fagersta",
    population: 13445.0,
    populationDensity: 49.98,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 644.48,
    areaLake: 26.26,
    areaLand: 604.27,
    areaSea: 0.0,
    boundsNeLat: 59.9912688,
    boundsNeLng: 15.8161737,
    boundsSwLat: 59.9634925,
    boundsSwLng: 15.7653594,
    centerLat: 59.9770336,
    centerLng: 15.7915677,
    code: 1983,
    name: "K\u00f6ping",
    population: 25950.0,
    populationDensity: 42.94,
  },
  {
    admin: "V\u00e4stmanlands län",
    area: 419.38,
    areaLake: 6.02,
    areaLand: 325.4,
    areaSea: 0.0,
    boundsNeLat: 59.41416,
    boundsNeLng: 15.9107909,
    boundsSwLat: 59.373032,
    boundsSwLng: 15.8011301,
    centerLat: 59.3936883,
    centerLng: 15.8381747,
    code: 1984,
    name: "Arboga",
    population: 13903.0,
    populationDensity: 42.73,
  },
  {
    admin: "Dalarnas län",
    area: 1657.34,
    areaLake: 117.79,
    areaLand: 1539.55,
    areaSea: 0.0,
    boundsNeLat: 60.5210514,
    boundsNeLng: 14.2507974,
    boundsSwLat: 60.5100677,
    boundsSwLng: 14.2187826,
    centerLat: 60.51556,
    centerLng: 14.23479,
    code: 2021,
    name: "Vansbro",
    population: 6884.0,
    populationDensity: 4.47,
  },
  {
    admin: "Dalarnas län",
    area: 4312.5,
    areaLake: 227.61,
    areaLand: 4084.89,
    areaSea: 0.0,
    boundsNeLat: 60.68507038,
    boundsNeLng: 13.71656328,
    boundsSwLat: 60.68237242,
    boundsSwLng: 13.71386532,
    centerLat: 60.6837214,
    centerLng: 13.7152143,
    code: 2023,
    name: "Malung-S\u00e4len",
    population: 10091.0,
    populationDensity: 2.47,
  },
  {
    admin: "Dalarnas län",
    area: 812.33,
    areaLake: 45.16,
    areaLand: 767.17,
    areaSea: 0.0,
    boundsNeLat: 60.6632441,
    boundsNeLng: 15.2864281,
    boundsSwLat: 60.2714809,
    boundsSwLng: 14.554339,
    centerLat: 60.4527768,
    centerLng: 14.8480045,
    code: 2026,
    name: "Gagnef",
    population: 10175.0,
    populationDensity: 13.26,
  },
  {
    admin: "Dalarnas län",
    area: 1411.98,
    areaLake: 190.72,
    areaLand: 1221.26,
    areaSea: 0.0,
    boundsNeLat: 60.5066917,
    boundsNeLng: 15.4043873,
    boundsSwLat: 60.5060252,
    boundsSwLng: 15.4038171,
    centerLat: 60.50623,
    centerLng: 15.4041053,
    code: 2029,
    name: "Leksand",
    population: 15507.0,
    populationDensity: 12.7,
  },
  {
    admin: "Dalarnas län",
    area: 2137.81,
    areaLake: 217.14,
    areaLand: 1920.67,
    areaSea: 0.0,
    boundsNeLat: 60.9045229,
    boundsNeLng: 15.1494699,
    boundsSwLat: 60.8589321,
    boundsSwLng: 15.0536739,
    centerLat: 60.889025,
    centerLng: 15.123373,
    code: 2031,
    name: "R\u00e4ttvik",
    population: 10856.0,
    populationDensity: 5.65,
  },
  {
    admin: "Dalarnas län",
    area: 1797.39,
    areaLake: 66.6,
    areaLand: 1730.79,
    areaSea: 0.0,
    boundsNeLat: 61.158687,
    boundsNeLng: 14.67871,
    boundsSwLat: 61.0739521,
    boundsSwLng: 14.583739,
    centerLat: 61.1169365,
    centerLng: 14.6280708,
    code: 2034,
    name: "Orsa",
    population: 6861.0,
    populationDensity: 3.96,
  },
  {
    admin: "Dalarnas län",
    area: 7142.83,
    areaLake: 270.92,
    areaLand: 6871.91,
    areaSea: 0.0,
    boundsNeLat: 62.2665581,
    boundsNeLng: 14.354617,
    boundsSwLat: 61.102689,
    boundsSwLng: 12.1380692,
    centerLat: 61.9321196,
    centerLng: 12.990459,
    code: 2039,
    name: "\u00c4lvdalen",
    population: 7039.0,
    populationDensity: 1.02,
  },
  {
    admin: "Dalarnas län",
    area: 1057.81,
    areaLake: 109.86,
    areaLand: 947.95,
    areaSea: 0.0,
    boundsNeLat: 60.14078608,
    boundsNeLng: 15.41645658,
    boundsSwLat: 60.13808812,
    boundsSwLng: 15.41375862,
    centerLat: 60.1394371,
    centerLng: 15.4151076,
    code: 2061,
    name: "Smedjebacken",
    population: 10909.0,
    populationDensity: 11.51,
  },
  {
    admin: "Dalarnas län",
    area: 3111.54,
    areaLake: 299.11,
    areaLand: 2812.43,
    areaSea: 0.0,
    boundsNeLat: 61.01049128,
    boundsNeLng: 14.54734778,
    boundsSwLat: 61.00779332,
    boundsSwLng: 14.54464982,
    centerLat: 61.0091423,
    centerLng: 14.5459988,
    code: 2062,
    name: "Mora",
    population: 20279.0,
    populationDensity: 7.21,
  },
  {
    admin: "Dalarnas län",
    area: 2275.22,
    areaLake: 234.95,
    areaLand: 2040.27,
    areaSea: 0.0,
    boundsNeLat: 60.60910398,
    boundsNeLng: 15.63101198,
    boundsSwLat: 60.60640602,
    boundsSwLng: 15.62831402,
    centerLat: 60.607755,
    centerLng: 15.629663,
    code: 2080,
    name: "Falun",
    population: 57685.0,
    populationDensity: 28.27,
  },
  {
    admin: "Dalarnas län",
    area: 635.82,
    areaLake: 51.9,
    areaLand: 583.92,
    areaSea: 0.0,
    boundsNeLat: 60.539025,
    boundsNeLng: 15.5445468,
    boundsSwLat: 60.4135011,
    boundsSwLng: 15.350771,
    centerLat: 60.484304,
    centerLng: 15.433969,
    code: 2081,
    name: "Borlänge",
    population: 51604.0,
    populationDensity: 88.38,
  },
  {
    admin: "Dalarnas län",
    area: 624.53,
    areaLake: 54.2,
    areaLand: 570.33,
    areaSea: 0.0,
    boundsNeLat: 60.9143143,
    boundsNeLng: 15.0214846,
    boundsSwLat: 60.9128243,
    boundsSwLng: 15.0168691,
    centerLat: 60.9135138,
    centerLng: 15.0193019,
    code: 2082,
    name: "S\u00e4ter",
    population: 11086.0,
    populationDensity: 19.44,
  },
  {
    admin: "Dalarnas län",
    area: 928.81,
    areaLake: 94.06,
    areaLand: 834.75,
    areaSea: 0.0,
    boundsNeLat: 60.550233,
    boundsNeLng: 16.3922129,
    boundsSwLat: 60.20903,
    boundsSwLng: 15.994295,
    centerLat: 60.369005,
    centerLng: 16.1508133,
    code: 2083,
    name: "Hedemora",
    population: 15461.0,
    populationDensity: 18.52,
  },
  {
    admin: "Dalarnas län",
    area: 669.03,
    areaLake: 55.83,
    areaLand: 613.2,
    areaSea: 0.0,
    boundsNeLat: 62.280241,
    boundsNeLng: 16.739265,
    boundsSwLat: 59.852169,
    boundsSwLng: 12.1331131,
    centerLat: 61.0917012,
    centerLng: 14.6663653,
    code: 2084,
    name: "Avesta",
    population: 23161.0,
    populationDensity: 37.77,
  },
  {
    admin: "Dalarnas län",
    area: 1647.81,
    areaLake: 157.44,
    areaLand: 1490.37,
    areaSea: 0.0,
    boundsNeLat: 60.2845509,
    boundsNeLng: 15.4390582,
    boundsSwLat: 59.9260671,
    boundsSwLng: 15.018307,
    centerLat: 60.0992705,
    centerLng: 15.2371951,
    code: 2085,
    name: "Ludvika",
    population: 26933.0,
    populationDensity: 18.07,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 1129.03,
    areaLake: 64.27,
    areaLand: 1064.76,
    areaSea: 0.0,
    boundsNeLat: 60.923201,
    boundsNeLng: 16.7513458,
    boundsSwLat: 60.8739289,
    boundsSwLng: 16.6848041,
    centerLat: 60.891784,
    centerLng: 16.7201873,
    code: 2101,
    name: "Ockelbo",
    population: 5856.0,
    populationDensity: 5.5,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 445.72,
    areaLake: 35.77,
    areaLand: 409.95,
    areaSea: 0.0,
    boundsNeLat: 60.5728501,
    boundsNeLng: 16.3261499,
    boundsSwLat: 60.5269281,
    boundsSwLng: 16.2578322,
    centerLat: 60.54595,
    centerLng: 16.2841,
    code: 2104,
    name: "Hofors",
    population: 9564.0,
    populationDensity: 23.33,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 2016.98,
    areaLake: 143.66,
    areaLand: 1873.32,
    areaSea: 0.0,
    boundsNeLat: 61.35108298,
    boundsNeLng: 16.39503698,
    boundsSwLat: 61.34838502,
    boundsSwLng: 16.39233902,
    centerLat: 61.349734,
    centerLng: 16.393688,
    code: 2121,
    name: "Ovan\u00e5ker",
    population: 11631.0,
    populationDensity: 6.21,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 2526.16,
    areaLake: 84.85,
    areaLand: 1370.48,
    areaSea: 1070.68,
    boundsNeLat: 62.2593851,
    boundsNeLng: 17.6414712,
    boundsSwLat: 61.816727,
    boundsSwLng: 16.1284588,
    centerLat: 62.0366675,
    centerLng: 17.205249,
    code: 2132,
    name: "Nordanstig",
    population: 9511.0,
    populationDensity: 6.94,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 5609.79,
    areaLake: 353.42,
    areaLand: 5256.37,
    areaSea: 0.0,
    boundsNeLat: 61.83405798,
    boundsNeLng: 16.10187718,
    boundsSwLat: 61.83136002,
    boundsSwLng: 16.09917922,
    centerLat: 61.832709,
    centerLng: 16.1005282,
    code: 2161,
    name: "Ljusdal",
    population: 19067.0,
    populationDensity: 3.63,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 3200.42,
    areaLake: 169.15,
    areaLand: 1613.84,
    areaSea: 1417.27,
    boundsNeLat: 60.74116,
    boundsNeLng: 17.3043159,
    boundsSwLat: 60.634524,
    boundsSwLng: 17.0749891,
    centerLat: 60.6748796,
    centerLng: 17.1412726,
    code: 2180,
    name: "G\u00e4vle",
    population: 99788.0,
    populationDensity: 61.83,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 1296.64,
    areaLake: 130.86,
    areaLand: 1165.78,
    areaSea: 0.0,
    boundsNeLat: 60.62296698,
    boundsNeLng: 16.77808018,
    boundsSwLat: 60.62026902,
    boundsSwLng: 16.77538222,
    centerLat: 60.621618,
    centerLng: 16.7767312,
    code: 2181,
    name: "Sandviken",
    population: 38949.0,
    populationDensity: 33.41,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 2281.34,
    areaLake: 110.98,
    areaLand: 1060.85,
    areaSea: 1109.51,
    boundsNeLat: 61.30614398,
    boundsNeLng: 17.05387498,
    boundsSwLat: 61.30344602,
    boundsSwLng: 17.05117702,
    centerLat: 61.304795,
    centerLng: 17.052526,
    code: 2182,
    name: "S\u00f6derhamn",
    population: 25992.0,
    populationDensity: 24.5,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 1976.64,
    areaLake: 162.6,
    areaLand: 1814.04,
    areaSea: 0.0,
    boundsNeLat: 61.377742,
    boundsNeLng: 16.4424279,
    boundsSwLat: 61.322606,
    boundsSwLng: 16.3288508,
    centerLat: 61.3483795,
    centerLng: 16.3942685,
    code: 2183,
    name: "Bolln\u00e4s",
    population: 26929.0,
    populationDensity: 14.84,
  },
  {
    admin: "G\u00e4vleborgs län",
    area: 4516.74,
    areaLake: 255.65,
    areaLand: 2489.05,
    areaSea: 1771.92,
    boundsNeLat: 61.763567,
    boundsNeLng: 17.1896928,
    boundsSwLat: 61.6976729,
    boundsSwLng: 17.0631818,
    centerLat: 61.7273909,
    centerLng: 17.107401,
    code: 2184,
    name: "Hudiksvall",
    population: 37299.0,
    populationDensity: 14.99,
  },
  {
    admin: "V\u00e4sternorrlands län",
    area: 3295.61,
    areaLake: 245.35,
    areaLand: 3050.26,
    areaSea: 0.0,
    boundsNeLat: 62.5332519,
    boundsNeLng: 15.6950731,
    boundsSwLat: 62.5126291,
    boundsSwLng: 15.6144858,
    centerLat: 62.5228738,
    centerLng: 15.6589419,
    code: 2260,
    name: "\u00c5nge",
    population: 9495.0,
    populationDensity: 3.11,
  },
  {
    admin: "V\u00e4sternorrlands län",
    area: 1234.31,
    areaLake: 39.45,
    areaLand: 783.26,
    areaSea: 411.45,
    boundsNeLat: 62.524969,
    boundsNeLng: 17.4205651,
    boundsSwLat: 62.469055,
    boundsSwLng: 17.2738009,
    centerLat: 62.4854563,
    centerLng: 17.3248651,
    code: 2262,
    name: "Timr\u00e5",
    population: 17992.0,
    populationDensity: 22.97,
  },
  {
    admin: "V\u00e4sternorrlands län",
    area: 1938.61,
    areaLake: 42.64,
    areaLand: 1058.32,
    areaSea: 837.62,
    boundsNeLat: 62.63178888,
    boundsNeLng: 17.94516378,
    boundsSwLat: 62.62909092,
    boundsSwLng: 17.94246582,
    centerLat: 62.6304399,
    centerLng: 17.9438148,
    code: 2280,
    name: "H\u00e4rn\u00f6sand",
    population: 25269.0,
    populationDensity: 23.88,
  },
  {
    admin: "V\u00e4sternorrlands län",
    area: 4444.61,
    areaLake: 262.58,
    areaLand: 3189.71,
    areaSea: 992.24,
    boundsNeLat: 62.4667477,
    boundsNeLng: 17.3972672,
    boundsSwLat: 62.324918,
    boundsSwLng: 17.1873897,
    centerLat: 62.390811,
    centerLng: 17.306927,
    code: 2281,
    name: "Sundsvall",
    population: 98325.0,
    populationDensity: 30.83,
  },
  {
    admin: "V\u00e4sternorrlands län",
    area: 2892.57,
    areaLake: 90.41,
    areaLand: 1694.65,
    areaSea: 1107.53,
    boundsNeLat: 62.9440551,
    boundsNeLng: 17.8398661,
    boundsSwLat: 62.911079,
    boundsSwLng: 17.7247079,
    centerLat: 62.9284332,
    centerLng: 17.7862947,
    code: 2282,
    name: "Kramfors",
    population: 18681.0,
    populationDensity: 11.02,
  },
  {
    admin: "V\u00e4sternorrlands län",
    area: 5761.82,
    areaLake: 365.34,
    areaLand: 5396.48,
    areaSea: 0.0,
    boundsNeLat: 63.186344,
    boundsNeLng: 17.3297261,
    boundsSwLat: 63.147983,
    boundsSwLng: 17.206697,
    centerLat: 63.1654065,
    centerLng: 17.277135,
    code: 2283,
    name: "Sollefte\u00e5",
    population: 19846.0,
    populationDensity: 3.68,
  },
  {
    admin: "V\u00e4sternorrlands län",
    area: 8429.04,
    areaLake: 363.09,
    areaLand: 6376.05,
    areaSea: 1689.85,
    boundsNeLat: 63.326957,
    boundsNeLng: 18.7993949,
    boundsSwLat: 63.239483,
    boundsSwLng: 18.5708369,
    centerLat: 63.2900474,
    centerLng: 18.7166166,
    code: 2284,
    name: "\u00d6rnsk\u00f6ldsvik",
    population: 55964.0,
    populationDensity: 8.78,
  },
  {
    admin: "J\u00e4mtlands län",
    area: 2633.1,
    areaLake: 122.14,
    areaLand: 2510.96,
    areaSea: 0.0,
    boundsNeLat: 63.514635,
    boundsNeLng: 16.9977869,
    boundsSwLat: 62.9164701,
    boundsSwLng: 15.2181678,
    centerLat: 63.1246168,
    centerLng: 16.3665889,
    code: 2303,
    name: "Ragunda",
    population: 5415.0,
    populationDensity: 2.16,
  },
  {
    admin: "J\u00e4mtlands län",
    area: 3783.41,
    areaLake: 375.32,
    areaLand: 3408.09,
    areaSea: 0.0,
    boundsNeLat: 63.3883316,
    boundsNeLng: 14.0160074,
    boundsSwLat: 63.3783336,
    boundsSwLng: 13.9839926,
    centerLat: 63.383333,
    centerLng: 14,
    code: 2305,
    name: "Br\u00e4cke",
    population: 6492.0,
    populationDensity: 1.9,
  },
  {
    admin: "J\u00e4mtlands län",
    area: 6812.61,
    areaLake: 658.16,
    areaLand: 6154.45,
    areaSea: 0.0,
    boundsNeLat: 63.2289599,
    boundsNeLng: 14.773303,
    boundsSwLat: 63.132397,
    boundsSwLng: 14.5108614,
    centerLat: 63.1766832,
    centerLng: 14.6360681,
    code: 2309,
    name: "Krokom",
    population: 14843.0,
    populationDensity: 2.41,
  },
  {
    admin: "J\u00e4mtlands län",
    area: 11780.83,
    areaLake: 1316.18,
    areaLand: 10464.65,
    areaSea: 0.0,
    boundsNeLat: 63.867565,
    boundsNeLng: 15.5832661,
    boundsSwLat: 63.839677,
    boundsSwLng: 15.5424191,
    centerLat: 63.8536621,
    centerLng: 15.5568691,
    code: 2313,
    name: "Str\u00f6msund",
    population: 11809.0,
    populationDensity: 1.13,
  },
  {
    admin: "J\u00e4mtlands län",
    area: 8236.46,
    areaLake: 1041.51,
    areaLand: 7194.95,
    areaSea: 0.0,
    boundsNeLat: 63.4074583,
    boundsNeLng: 13.1106945,
    boundsSwLat: 63.386836,
    boundsSwLng: 13.047816,
    centerLat: 63.3990428,
    centerLng: 13.0815059,
    code: 2321,
    name: "\u00c5re",
    population: 11088.0,
    populationDensity: 1.54,
  },
  {
    admin: "J\u00e4mtlands län",
    area: 6145.46,
    areaLake: 435.28,
    areaLand: 5710.18,
    areaSea: 0.0,
    boundsNeLat: 63.081067,
    boundsNeLng: 14.878175,
    boundsSwLat: 62.289538,
    boundsSwLng: 12.070339,
    centerLat: 62.7724812,
    centerLng: 14.1698666,
    code: 2326,
    name: "Berg",
    population: 7081.0,
    populationDensity: 1.24,
  },
  {
    admin: "J\u00e4mtlands län",
    area: 11859.63,
    areaLake: 575.8,
    areaLand: 11283.83,
    areaSea: 0.0,
    boundsNeLat: 62.642023,
    boundsNeLng: 14.373635,
    boundsSwLat: 61.7599261,
    boundsSwLng: 12.0744849,
    centerLat: 62.2944578,
    centerLng: 13.1942936,
    code: 2361,
    name: "H\u00e4rjedalen",
    population: 10200.0,
    populationDensity: 0.9,
  },
  {
    admin: "J\u00e4mtlands län",
    area: 2501.09,
    areaLake: 292.8,
    areaLand: 2208.29,
    areaSea: 0.0,
    boundsNeLat: 63.2289599,
    boundsNeLng: 14.773303,
    boundsSwLat: 63.132397,
    boundsSwLng: 14.5108614,
    centerLat: 63.1766832,
    centerLng: 14.6360681,
    code: 2380,
    name: "\u00d6stersund",
    population: 61745.0,
    populationDensity: 27.96,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 2472.47,
    areaLake: 40.21,
    areaLand: 1229.59,
    areaSea: 1202.46,
    boundsNeLat: 63.580474,
    boundsNeLng: 19.5355647,
    boundsSwLat: 63.56019,
    boundsSwLng: 19.4710248,
    centerLat: 63.566667,
    centerLng: 19.5,
    code: 2401,
    name: "Nordmaling",
    population: 7132.0,
    populationDensity: 5.8,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 1363.76,
    areaLake: 56.99,
    areaLand: 1306.77,
    areaSea: 0.0,
    boundsNeLat: 63.938525,
    boundsNeLng: 19.24159,
    boundsSwLat: 63.919804,
    boundsSwLng: 19.1977812,
    centerLat: 63.9304056,
    centerLng: 19.2192125,
    code: 2403,
    name: "Bjurholm",
    population: 2454.0,
    populationDensity: 1.88,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 2846.87,
    areaLake: 216.82,
    areaLand: 2630.05,
    areaSea: 0.0,
    boundsNeLat: 64.20325308,
    boundsNeLng: 19.72018758,
    boundsSwLat: 64.20055512,
    boundsSwLng: 19.71748962,
    centerLat: 64.2019041,
    centerLng: 19.7188386,
    code: 2404,
    name: "Vindeln",
    population: 5413.0,
    populationDensity: 2.06,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 2369.78,
    areaLake: 21.06,
    areaLand: 1292.32,
    areaSea: 1056.28,
    boundsNeLat: 66.340329,
    boundsNeLng: 21.6169479,
    boundsSwLat: 63.4054636,
    boundsSwLng: 14.2568099,
    centerLat: 65.3337311,
    centerLng: 16.5161695,
    code: 2409,
    name: "Robertsfors",
    population: 6784.0,
    populationDensity: 5.25,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 1923.58,
    areaLake: 184.43,
    areaLand: 1739.15,
    areaSea: 0.0,
    boundsNeLat: 64.9246391,
    boundsNeLng: 19.5192788,
    boundsSwLat: 64.902527,
    boundsSwLng: 19.4544337,
    centerLat: 64.9135093,
    centerLng: 19.4826413,
    code: 2417,
    name: "Norsj\u00f6",
    population: 4125.0,
    populationDensity: 2.37,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 1727.48,
    areaLake: 129.27,
    areaLand: 1598.21,
    areaSea: 0.0,
    boundsNeLat: 65.1990739,
    boundsNeLng: 18.7692682,
    boundsSwLat: 65.1706689,
    boundsSwLng: 18.7045171,
    centerLat: 65.18512,
    centerLng: 18.74907,
    code: 2418,
    name: "Mal\u00e5",
    population: 3100.0,
    populationDensity: 1.94,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 8234.13,
    areaLake: 934.49,
    areaLand: 7299.64,
    areaSea: 0.0,
    boundsNeLat: 66.150592,
    boundsNeLng: 16.716909,
    boundsSwLat: 65.334505,
    boundsSwLng: 14.4952551,
    centerLat: 65.5629922,
    centerLng: 15.2948303,
    code: 2421,
    name: "Storuman",
    population: 5899.0,
    populationDensity: 0.81,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 7957.69,
    areaLake: 590.65,
    areaLand: 7367.04,
    areaSea: 0.0,
    boundsNeLat: 65.540059,
    boundsNeLng: 17.5432955,
    boundsSwLat: 65.5308172,
    boundsSwLng: 17.5112807,
    centerLat: 65.5354385,
    centerLng: 17.5272881,
    code: 2422,
    name: "Sorsele",
    population: 2535.0,
    populationDensity: 0.34,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 2939.91,
    areaLake: 175.38,
    areaLand: 2764.53,
    areaSea: 0.0,
    boundsNeLat: 64.272768,
    boundsNeLng: 16.441826,
    boundsSwLat: 64.2527589,
    boundsSwLng: 16.381826,
    centerLat: 64.2617939,
    centerLng: 16.4152338,
    code: 2425,
    name: "Dorotea",
    population: 2719.0,
    populationDensity: 0.98,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 553.7,
    areaLake: 24.21,
    areaLand: 529.49,
    areaSea: 0.0,
    boundsNeLat: 63.90681208,
    boundsNeLng: 19.75279948,
    boundsSwLat: 63.90411412,
    boundsSwLng: 19.75010152,
    centerLat: 63.9054631,
    centerLng: 19.7514505,
    code: 2460,
    name: "V\u00e4nn\u00e4s",
    population: 8695.0,
    populationDensity: 16.42,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 8740.52,
    areaLake: 692.09,
    areaLand: 8048.43,
    areaSea: 0.0,
    boundsNeLat: 64.2134402,
    boundsNeLng: 17.3712367,
    boundsSwLat: 64.1678932,
    boundsSwLng: 17.3131354,
    centerLat: 64.1909375,
    centerLng: 17.3430378,
    code: 2462,
    name: "Vilhelmina",
    population: 6805.0,
    populationDensity: 0.85,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 4543.71,
    areaLake: 320.19,
    areaLand: 4223.52,
    areaSea: 0.0,
    boundsNeLat: 64.1672645,
    boundsNeLng: 17.3699063,
    boundsSwLat: 64.1575387,
    boundsSwLng: 17.3378915,
    centerLat: 64.162402,
    centerLng: 17.3538989,
    code: 2463,
    name: "\u00c5sele",
    population: 2875.0,
    populationDensity: 0.68,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 5215.03,
    areaLake: 80.49,
    areaLand: 2317.12,
    areaSea: 2815.78,
    boundsNeLat: 63.875971,
    boundsNeLng: 20.365735,
    boundsSwLat: 63.777877,
    boundsSwLng: 20.118188,
    centerLat: 63.8258471,
    centerLng: 20.2630354,
    code: 2480,
    name: "Ume\u00e5",
    population: 122892.0,
    populationDensity: 53.04,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 5888.93,
    areaLake: 370.75,
    areaLand: 5518.18,
    areaSea: 0.0,
    boundsNeLat: 64.1686722,
    boundsNeLng: 17.3886543,
    boundsSwLat: 64.1661122,
    boundsSwLng: 17.37378,
    centerLat: 64.168142,
    centerLng: 17.3806303,
    code: 2481,
    name: "Lycksele",
    population: 12187.0,
    populationDensity: 2.21,
  },
  {
    admin: "V\u00e4sterbottens län",
    area: 9956.9,
    areaLake: 373.73,
    areaLand: 6800.56,
    areaSea: 2782.92,
    boundsNeLat: 64.74757608,
    boundsNeLng: 20.95866708,
    boundsSwLat: 64.74487812,
    boundsSwLng: 20.95596912,
    centerLat: 64.7462271,
    centerLng: 20.9573181,
    code: 2482,
    name: "Skellefte\u00e5",
    population: 72266.0,
    populationDensity: 10.63,
  },
  {
    admin: "Norrbottens län",
    area: 6126.3,
    areaLake: 470.71,
    areaLand: 5655.59,
    areaSea: 0.0,
    boundsNeLat: 65.3184807,
    boundsNeLng: 21.4001671,
    boundsSwLat: 65.3126918,
    boundsSwLng: 21.317374,
    centerLat: 65.3165601,
    centerLng: 21.3567714,
    code: 2505,
    name: "Arvidsjaur",
    population: 6442.0,
    populationDensity: 1.14,
  },
  {
    admin: "Norrbottens län",
    area: 14494.16,
    areaLake: 1936.57,
    areaLand: 12557.59,
    areaSea: 0.0,
    boundsNeLat: 66.0557289,
    boundsNeLng: 17.9137616,
    boundsSwLat: 66.03603,
    boundsSwLng: 17.8361258,
    centerLat: 66.0515051,
    centerLng: 17.8900543,
    code: 2506,
    name: "Arjeplog",
    population: 2876.0,
    populationDensity: 0.23,
  },
  {
    admin: "Norrbottens län",
    area: 19334.4,
    areaLake: 1733.64,
    areaLand: 17600.76,
    areaSea: 0.0,
    boundsNeLat: 66.6128031,
    boundsNeLng: 19.904502,
    boundsSwLat: 66.5887509,
    boundsSwLng: 19.7951527,
    centerLat: 66.6069609,
    centerLng: 19.8229206,
    code: 2510,
    name: "Jokkmokk",
    population: 5105.0,
    populationDensity: 0.29,
  },
  {
    admin: "Norrbottens län",
    area: 2919.47,
    areaLake: 154.95,
    areaLand: 2764.52,
    areaSea: 0.0,
    boundsNeLat: 69.063072,
    boundsNeLng: 24.1624078,
    boundsSwLat: 65.060635,
    boundsSwLng: 15.3723748,
    centerLat: 66.8309216,
    centerLng: 20.3991966,
    code: 2513,
    name: "\u00d6verkalix",
    population: 3378.0,
    populationDensity: 1.22,
  },
  {
    admin: "Norrbottens län",
    area: 3710.85,
    areaLake: 100.68,
    areaLand: 1803.08,
    areaSea: 1808.3,
    boundsNeLat: 65.85696488,
    boundsNeLng: 23.14614788,
    boundsSwLat: 65.85426692,
    boundsSwLng: 23.14344992,
    centerLat: 65.8556159,
    centerLng: 23.1447989,
    code: 2514,
    name: "Kalix",
    population: 16223.0,
    populationDensity: 9.0,
  },
  {
    admin: "Norrbottens län",
    area: 2492.52,
    areaLake: 130.22,
    areaLand: 2362.3,
    areaSea: 0.0,
    boundsNeLat: 66.9843479,
    boundsNeLng: 24.0008159,
    boundsSwLat: 66.0592751,
    boundsSwLng: 23.0061231,
    centerLat: 66.5158379,
    centerLng: 23.5729618,
    code: 2518,
    name: "\u00d6vertorne\u00e5",
    population: 4534.0,
    populationDensity: 1.92,
  },
  {
    admin: "Norrbottens län",
    area: 8050.71,
    areaLake: 210.41,
    areaLand: 7840.3,
    areaSea: 0.0,
    boundsNeLat: 69.063072,
    boundsNeLng: 24.1624078,
    boundsSwLat: 65.060635,
    boundsSwLng: 15.3723748,
    centerLat: 66.8309216,
    centerLng: 20.3991966,
    code: 2521,
    name: "Pajala",
    population: 6116.0,
    populationDensity: 0.78,
  },
  {
    admin: "Norrbottens län",
    area: 16818.24,
    areaLake: 1127.46,
    areaLand: 15690.78,
    areaSea: 0.0,
    boundsNeLat: 68.1217059,
    boundsNeLng: 22.5038398,
    boundsSwLat: 66.727598,
    boundsSwLng: 16.114486,
    centerLat: 67.5021116,
    centerLng: 19.0487443,
    code: 2523,
    name: "G\u00e4llivare",
    population: 17956.0,
    populationDensity: 1.14,
  },
  {
    admin: "Norrbottens län",
    area: 1795.24,
    areaLake: 96.0,
    areaLand: 1699.24,
    areaSea: 0.0,
    boundsNeLat: 65.690748,
    boundsNeLng: 21.0586047,
    boundsSwLat: 65.65638,
    boundsSwLng: 20.9665278,
    centerLat: 65.6771363,
    centerLng: 20.9928659,
    code: 2560,
    name: "\u00c4lvsbyn",
    population: 8193.0,
    populationDensity: 4.82,
  },
  {
    admin: "Norrbottens län",
    area: 4962.19,
    areaLake: 148.39,
    areaLand: 2094.08,
    areaSea: 2711.28,
    boundsNeLat: 65.629758,
    boundsNeLng: 22.3051211,
    boundsSwLat: 65.5444445,
    boundsSwLng: 22.057593,
    centerLat: 65.584819,
    centerLng: 22.1567026,
    code: 2580,
    name: "Lule\u00e5",
    population: 76770.0,
    populationDensity: 36.66,
  },
  {
    admin: "Norrbottens län",
    area: 4678.23,
    areaLake: 149.04,
    areaLand: 3086.04,
    areaSea: 1445.45,
    boundsNeLat: 65.3475283,
    boundsNeLng: 21.5589681,
    boundsSwLat: 65.261912,
    boundsSwLng: 21.3986559,
    centerLat: 65.316698,
    centerLng: 21.4800364,
    code: 2581,
    name: "Pite\u00e5",
    population: 41904.0,
    populationDensity: 13.58,
  },
  {
    admin: "Norrbottens län",
    area: 4285.1,
    areaLake: 277.21,
    areaLand: 4007.89,
    areaSea: 0.0,
    boundsNeLat: 65.8555831,
    boundsNeLng: 21.781993,
    boundsSwLat: 65.7888981,
    boundsSwLng: 21.5470054,
    centerLat: 65.8251188,
    centerLng: 21.6887028,
    code: 2582,
    name: "Boden",
    population: 28042.0,
    populationDensity: 7.0,
  },
  {
    admin: "Norrbottens län",
    area: 1866.62,
    areaLake: 38.58,
    areaLand: 921.27,
    areaSea: 908.42,
    boundsNeLat: 65.6408692,
    boundsNeLng: 22.138269,
    boundsSwLat: 65.6016965,
    boundsSwLng: 22.1167018,
    centerLat: 65.621281,
    centerLng: 22.1271203,
    code: 2583,
    name: "Haparanda",
    population: 9864.0,
    populationDensity: 10.71,
  },
  {
    admin: "Norrbottens län",
    area: 20551.45,
    areaLake: 1396.08,
    areaLand: 19155.37,
    areaSea: 0.0,
    boundsNeLat: 67.8841239,
    boundsNeLng: 20.368803,
    boundsSwLat: 67.8232801,
    boundsSwLng: 20.1440569,
    centerLat: 67.8557995,
    centerLng: 20.2252821,
    code: 2584,
    name: "Kiruna",
    population: 23167.0,
    populationDensity: 1.21,
  },
];

const countiesRaw = org.map(function(kommun){
    return kommun.admin;
}); 
export const counties = [...new Set(countiesRaw)];
counties.sort(); 


export const kommuner = org.sort(function (k1, k2) {
  if (k1.name > k2.name) {
    return 1;
  }
  if (k1.name < k2.name) {
    return -1;
  }
  return 0;
}); 